<template>
  <div>
    <b-alert
      :show="showExpiryWarning"
      variant="warning"
      dismissible
      class="mb-3"
      @dismissed="expiryWarningDismissed = true"
    >
      <strong v-if="lang === 'en'">⏳ Your package is about to expire</strong>
      <strong v-else>⏳ Tu paquete está por vencer</strong>
      <div class="mt-1">{{ expiryWarningMessage }}</div>
    </b-alert>
    <div class="content-loader" v-show="flagCancelClass">
      <div class="loader"></div>
    </div>
    <b-toast
      id="toast-check-modal-calendar-class"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-modal-calendar-class"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-modal-request-class-student"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-breadcrumb>
      <b-breadcrumb-item active>{{
        $t("horario.breadcrumb.titulo")
      }}</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="card content-main" style="padding: 3rem">
      <div v-if="showLoadingFirst" class="container-loading">
        <b-spinner :label="$t('reusables.loading')"></b-spinner>
      </div>
      <div v-else>
        <div>
          <div class="card card-next-class-2" v-if="nextDateClass">
            <div class="left">
              <img src="@/assets/img/girdRequest-2.png" />
              <h6 class="sub-title">
                <span>{{ $t("horario.next-class.nextClass") }}</span>
              </h6>
            </div>
            <div>
              <div class="right">
                <span><icon name="calendar" />{{ nextDateClass }}</span>
                <span><icon name="time" />{{ nextClass }}</span>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-primary"
              :class="nextClassLink != null ? '' : 'disabled'"
              @click="openLinkClassLocal(nextClassLink)"
            >
              <icon name="video" />{{ $t("horario.next-class.button-pass") }}
            </button>
            <!-- <button type="button" class="btn btn-primary" :class="nextClass && nextClass.linkClass != null? '': 'disabled'"  @click="openLinkClass(nextClass.linkClass)">
                      <b-icon icon="camera-video" aria-hidden="true"></b-icon>{{$t('horario.next-class.button-pass')}}
                  </button> -->
          </div>
          <b-row v-if="false">
            <b-col style="display: flex">
              <div class="card card-next-class">
                <div class="left">
                  <img src="@/assets/img/girdRequest.png" class="mr-3" />
                  <div v-if="nextDateClass" class="time mr-2">
                    <h6>{{ $t("horario.next-class.nextClass") }}</h6>
                    <span style="font-size: 14px">{{ nextDateClass }}</span>
                    <span style="font-size: 14px">{{ nextClass }}</span>
                  </div>
                  <div v-else>
                    <p>{{ $t("reusables.no-class-schedule") }}</p>
                  </div>
                </div>
                <button
                  v-if="nextDateClass"
                  type="button"
                  class="btn btn-primary"
                  :class="nextClassLink != null ? '' : 'disabled'"
                  @click="openLinkClassLocal(nextClassLink)"
                >
                  <icon name="video" />{{
                    $t("horario.next-class.button-pass")
                  }}
                </button>
              </div>
            </b-col>
            <b-col>
              <div class="card card_teacher list" style="padding: 20px">
                <div class="d-flex">
                  <div class="perfil">
                    <b-avatar
                      variant="light"
                      :src="dataTeacher.photo ? dataTeacher.photo : urlPhoto"
                      size="4.5rem"
                    ></b-avatar>
                    <b-form-rating
                      :value="dataTeacher.totalQualification"
                      readonly
                      no-border
                    ></b-form-rating>
                    <b-link
                      @click="getTeacherInformationAndComments(dataTeacher.id)"
                      >{{ dataTeacher.totalCommentary }}
                      {{ $t("horario.next-class.link") }}</b-link
                    >
                  </div>
                  <div class="info">
                    <h6>{{ dataTeacher.strFullName }}</h6>
                    <p><icon name="location" />{{ dataTeacher.location }}</p>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="calendar">
          <div
            class="ea-alert mt-4"
            v-if="showEditSchedule && !isResponseReceived"
          >
            <icon name="alert-2" />
            <div class="content">
              <p>
                {{ $t("reusables.student-edited-schedule") }} <br />
                <b-link class="bold" @click="modalSchedule">{{
                  $t("reusables.student-edited-schedule-1")
                }}</b-link>
              </p>
            </div>
          </div>
          <div
            class="ea-alert mt-4"
            v-if="showEditSchedule && isResponseReceived"
          >
            <icon name="alert-2" />
            <div class="content">
              <p>
                {{ $t("reusables.student-edited-schedule-6") }}<br />
                <b-link class="bold" @click="modalSchedule"
                  >{{ $t("reusables.student-edited-schedule-7") }}
                </b-link>
              </p>
            </div>
          </div>
          <div class="body-header pt-4" style="position: relative">
            <div
              class="content-buttons"
              :style= "[!flagShowHeader ? 
                {'position': 'relative'} : 
                {
                  'bottom': '-2.3rem',
                  'display': 'flex',
                  'justify-content': 'flex-end',
                  'position': 'absolute',
                  'right': '0px',
                  'z-index': '10',
                }]"
              v-if="isRepresentative"
            >
              <!-- <b-button variant="outline-primary"  v-if="showEditSchedule"  @click="modalSchedule"  class="btn-outline mr-4 "><icon name="calendar" />{{$t('horario.next-class.see-edition')}}</b-button> -->
              <b-button
                variant="danger"
                class="ml-4"
                :style="`${
                  flagShowHeader
                    ? ''
                    : 'position: relative;bottom:25px;z-index:10 '
                }`"
                @click="reply"
                v-if="!showEditSchedule && flagEdit"
                ><icon name="undo" />{{ $t("horario.reply.text") }}</b-button
              >
              <b-button
                variant="outline-primary"
                @click="showModalEditarHorario"
                :disabled="disabledButton"
                v-if="!showEditSchedule && flagEdit"
                class="btn-outline ml-4"
                :style="`${
                  flagShowHeader
                    ? ''
                    : 'position: relative;bottom:25px;z-index:10 '
                }`"
                ><icon name="edit-pencil" />{{
                  $t("horario.next-class.save-changes")
                }}
              </b-button>
              <b-button
                variant="outline-primary"
                v-if="!showEditSchedule && !flagEdit"
                @click="editCalendar"
                v-show="flagPlanTest?false:!hideButtonsForEdit"
                class="ml-4"
                :style="`${
                  flagShowHeader
                    ? ''
                    : 'position: relative;z-index:10 '
                }`"
                ><icon name="edit-pencil" />{{
                  $t("horario.next-class.edit-schedule")
                }}</b-button
              >
              <!-- <b-button
                variant="primary"
                v-if="!showEditSchedule && !flagEdit && !flagPlanTest"
                @click="getTeacherChanges"
                v-show="!hideButtonsForEdit"
                :style="
                  'position: relative;bottom: ' +
                  `${flagShowHeader ? '-38px' : 0}` +
                  ';z-index:10'
                "
                >{{ $t("horario.next-class.changue-teacher") }}</b-button 
              >-->
            </div>
          </div>
        </div>
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="warning"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          {{ $t("horario.calendario.text.6") }} {{ dismissCountDown }}
        </b-alert>
        <!-- 
             :min ="minDate"
                    :max ="maxDate"
                    :disabled="!disabledDate"
            <div v-if="showLoading" class="container-loading">
            <b-spinner :label="$t('reusables.loading')" ></b-spinner>
          </div>-->
        <div v-if="showLoadingCalendar" class="container-loading">
          <b-spinner :label="$t('reusables.loading')"></b-spinner>
        </div>
        <div v-else class="container-calendar" style="position: relative">
          <div
            class="body-header edit"
            v-show="!hideButtonsForEdit"
            style="position: absolute; left: 200px; width: 150px; top: 3px"
            v-if="getShowSelect || flagPlanTestEdit"
          >
            <CustomSelect
              @input="idValueSelectEventSelectedTime"
              :options="optionsTime"
              value="value"
              label="text"
              :default="null"
              :defaultValue="this.selectedTime"
              :isActiveMethodValidOpcion="true"
              @change="getWeek()"
            />
            <!-- <b-form-select class="custom-select" v-model="selectedTime" :options="optionsTime" @change="getWeek"></b-form-select> -->
          </div>

          <FullCalendar
            class="demo-app-calendar"
            :options="calendarOptions"
            :custom-buttons="calendarOptions.customButtons"
            ref="fullCalendarStudent"
          >
            <!-- display-header para que desaparezca las opciones-->

            <template v-slot:eventContent="arg">
              <div class="fc-event-main-frame" @click="getDataClass(arg.event)">
                <span
                  v-show="
                    arg.event.startEditable && isFutureEvent(arg.event.start)
                  "
                  style="font-size: 1.1rem"
                  @click.stop.prevent="removeEvent(arg.event)"
                  ><icon name="close-2"
                /></span>
                <!-- <span v-show="arg.event.startEditable" style="font-size: 1.1rem;"  @click.stop.prevent="removeEvent(arg.event)" class="material-icons-outlined">delete</span> -->
                <span
                  v-show="
                    !flagEdit &&
                    arg.event.extendedProps.linkClass == null &&
                    !arrStatusNotEditableLinkClass.includes(
                      arg.event.extendedProps.stateClass
                    )
                  "
                  class="material-icons"
                  style="color: red"
                  >priority_high</span
                >

                <div class="fc-event-time">{{ arg.timeText }}</div>
                <div class="fc-event-title-container">
                  {{ arg.event.title }}
                </div>
              </div>
            </template>
          </FullCalendar>
        </div>
      </div>
      <!--MODAL ELIMINAR CLASE RECURRENTE-->
      <b-modal
        id="delete-recurring-class"
        :centered="true"
        body-class="pt-2"
        footer-class="justify-content-center"
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
          <h4 class="bold text-center">
            {{ $t("reusables.student-edited-delete-recurrent-classes-title") }}
          </h4>
        </template>
        <div style="font-size: 15px">
          <div class="mx-auto" style="max-width: 300px">
            <p class="d-flex align-items-center mb-2">
              <icon name="calendar" class="mr-2 icon-blue-dark" />
              {{
                infoEventoDelete.startDate != null &&
                infoEventoDelete.endDate != null
                  ? getFormatDateCompleteClass(
                      infoEventoDelete.startDate,
                      infoEventoDelete.endDate
                    )
                  : ""
              }}
            </p>
            <p class="d-flex align-items-center mb-2">
              <icon name="time" class="mr-2 icon-blue-dark" />
              {{
                infoEventoDelete.startDate != null &&
                infoEventoDelete.endDate != null
                  ? getFormatDateCompleteTitleTime(
                      infoEventoDelete.startDate,
                      infoEventoDelete.endDate
                    )
                  : ""
              }}
            </p>
          </div>
          <div class="mx-auto mt-4" style="max-width: 245px">
            <b-form-radio
              name="some-radios"
              value="true"
              v-model="classDelete.typeClass"
              >{{ $t("reusables.this-class") }}</b-form-radio
            >
            <b-form-radio
              name="some-radios"
              value="false"
              v-model="classDelete.typeClass"
              >{{ $t("reusables.this-class-following") }}</b-form-radio
            >
            <span class="error-input">{{
              validationForm($v.classDelete.typeClass)
            }}</span>
          </div>
        </div>
        <template #modal-footer>
          <b-button
            variant="danger"
            @click="$bvModal.hide('delete-recurring-class')"
            >{{ $t("reusables.cancel") }}</b-button
          >
          <b-button variant="primary" @click="SaveClassDelete">
            <template v-if="!showSpinnerSend">{{
              $t("reusables.delete")
            }}</template>
          </b-button>
        </template>
      </b-modal>
      <!-- ------- -->
      <!--MODAL AGREGAR CLASE-->
      <b-modal
        id="modal-add-class"
        :centered="true"
        body-class="pt-2"
        footer-class="justify-content-center"
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
          <h4 class="bold text-center">
            {{ $t("reusables.student-edited-add-classes-title") }}
          </h4>
        </template>
        <div style="font-size: 15px">
          <div class="mx-auto" style="max-width: 300px">
            <p class="d-flex align-items-center mb-2">
              <icon name="calendar" class="mr-2 icon-blue-dark" />
              {{
                this.eventCreated != null
                  ? getFormatDateCompleteClass(
                      this.eventCreated.startStr,
                      this.eventCreated.endStr
                    )
                  : ""
              }}
            </p>
            <p class="d-flex align-items-center mb-2">
              <icon name="time" class="mr-2 icon-blue-dark" />
              {{
                this.eventCreated != null
                  ? getFormatDateCompleteTitleTime(
                      this.eventCreated.startStr,
                      this.eventCreated.endStr
                    )
                  : ""
              }}
            </p>
          </div>
          <div class="mx-auto mt-4" style="max-width: 245px">
            <b-form-radio
              name="some-radios"
              value="true"
              v-model.trim="classRegister.typeClass"
              >{{ $t("reusables.notRepeated") }}</b-form-radio
            >
            <b-form-radio
              name="some-radios"
              v-model.trim="classRegister.typeClass"
              value="false"
              >{{ $t("reusables.repeats-every-week") }}</b-form-radio
            >
            <span class="error-input">{{
              validationForm($v.classRegister.typeClass)
            }}</span>
          </div>
        </div>
        <template #modal-footer>
          <b-button
            variant="danger"
            @click="$bvModal.hide('modal-add-class')"
            >{{ $t("reusables.cancel") }}</b-button
          >
          <b-button variant="primary" @click="SaveClassRegister">
            <template v-if="!showSpinnerSend">{{
              $t("reusables.class-add")
            }}</template>
          </b-button>
        </template>
      </b-modal>
      <!-- ------- -->
      <!--MODAL ELIMINAR CLASE-->
      <b-modal
        id="modal-delete-class"
        :centered="true"
        body-class="pt-2"
        footer-class="justify-content-center"
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
          <h4 class="bold text-center">
            {{ $t("reusables.student-edited-delete-classes-title") }}
          </h4>
        </template>
        <div style="font-size: 15px">
          <div class="mx-auto" style="max-width: 300px">
            <p class="d-flex align-items-center mb-2">
              <icon name="calendar" class="mr-2 icon-blue-dark" />
              {{
                infoEventoDelete.startDate != null &&
                infoEventoDelete.endDate != null
                  ? getFormatDateCompleteClass(
                      infoEventoDelete.startDate,
                      infoEventoDelete.endDate
                    )
                  : ""
              }}
            </p>
            <p class="d-flex align-items-center mb-2">
              <icon name="time" class="mr-2 icon-blue-dark" />
              {{
                infoEventoDelete.startDate != null &&
                infoEventoDelete.endDate != null
                  ? getFormatDateCompleteTitleTime(
                      infoEventoDelete.startDate,
                      infoEventoDelete.endDate
                    )
                  : ""
              }}
            </p>
          </div>
        </div>
        <template #modal-footer>
          <b-button
            variant="danger"
            @click="$bvModal.hide('modal-delete-class')"
            >{{ $t("reusables.cancel") }}</b-button
          >
          <b-button variant="primary" @click="SaveClassDeleteNoRecurrent">
            <template v-if="!showSpinnerSend">{{
              $t("reusables.delete")
            }}</template>
            <!-- <b-spinner
                  style="width: 1rem !important; height: 1rem !important"
                  v-else
                  variant="light"
                  label="Spinning"
                ></b-spinner> -->
          </b-button>
        </template>
      </b-modal>
      <!-- ------- -->
      <!--MODAL ELIMINAR CLASE(SIN RESULTADO)-->
      <b-modal
        id="modal-delete-class-without-result"
        :centered="true"
        body-class="pt-2"
        footer-class="justify-content-center"
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
          <h4 class="bold text-center">
            {{ $t("reusables.student-edited-delete-classes-title") }}
          </h4>
        </template>
        <div style="font-size: 15px">
          <div class="mx-auto" style="max-width: 220px">
            <p class="d-flex align-items-center mb-">
              {{ $t("reusables.there-no-class-eliminate") }}
            </p>
          </div>
        </div>
        <template #modal-footer>
          <b-button
            variant="danger"
            @click="$bvModal.hide('modal-delete-class-without-result')"
            >{{ $t("reusables.cancel") }}</b-button
          >
        </template>
      </b-modal>
      <!-- ------- -->
      <!--MODAL VALIDAR CLASE PARA AGREGAR-->
      <b-modal
        id="modal-validate-register-class"
        :centered="true"
        body-class="pt-2"
        footer-class="justify-content-center"
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
        </template>
        <p class="text-center mb-0">
          {{ messageAddClass }}
        </p>
        <template #modal-footer>
          <b-button
            variant="danger"
            @click="$bvModal.hide('modal-validate-register-class')"
            >{{ $t("reusables.cancel") }}</b-button
          >
        </template>
      </b-modal>
      <!-- ------- -->
      <div>
        <b-modal id="modal-save-change" :modal-class="!(groupsPlan != null && groupsPlan.flagPlanTest) ? 'modal-alert-lg' : ''" :centered="true">
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <p class="bold mb-0" v-if="!(groupsPlan != null && groupsPlan.flagPlanTest)">
              {{ $t("reusables.student-edited-schedule-2") }}
            </p>
          </template>
            <p class="text-center mb-0" v-if="(groupsPlan != null && groupsPlan.flagPlanTest)">
              {{ $t("reusables.student-edited-schedule-2") }}
            </p>  
          <div
            class="ea-alert px-4 mb-0"
            v-if="!(groupsPlan != null && groupsPlan.flagPlanTest)"
          >
            <div class="content pl-0">
              <div class="d-flex justify-content-center" style="gap: 5rem">
                <div class="text-left">
                  <p class="bold">
                    {{ $t("reusables.student-edited-recurring-schedule") }}:
                  </p>
                  <ul class="mb-0" v-if="listRecurrent.length > 0">
                    <li v-for="item in listRecurrent" :key="item.date">
                      {{ item.date }}
                    </li>
                  </ul>
                  <p class="mb-0" v-else></p>
                </div>
                <div class="text-left">
                  <p class="bold">
                    {{ $t("reusables.student-edited-add-classes") }}:
                  </p>
                  <ul
                    class="mb-0"
                    v-if="
                      calendarOptions.events.filter((currentValue) => {
                        return (
                          currentValue.editable &&
                          !(currentValue.noRecurrent == false)
                        );
                      }).length > 0
                    "
                  >
                    <li
                      v-for="item in calendarOptions.events
                        .filter((currentValue) => {
                          return (
                            currentValue.editable &&
                            !(currentValue.noRecurrent == false)
                          );
                        })
                        .sort((a, b) => new Date(a.start) - new Date(b.start))"
                      :key="item.start"
                      :class="{
                        'red-item': item.isInList,
                      }"
                    >
                      {{ getFormatDateCompleteDetail(item.start, item.end) }}
                    </li>
                  </ul>
                  <p class="mb-0" v-else></p>
                </div>
              </div>
              <div
                class="d-flex justify-content-center mt-4 form-group mx-auto align-items-center"
                style="gap: 1rem; max-width: 20rem"
                v-if="listResult.length > 0"
              >
                <p class="mb-0 bold">
                  {{ $t("reusables.student-edited-schedule-17") }}
                </p>
              </div>
            </div>
          </div>

          <template #modal-footer>
            <div class="d-flex justify-content-center w-100">
              <b-button
                variant="danger"
                @click="$bvModal.hide('modal-save-change')"
                >{{ $t("modals.cancel-request.button-cancel") }}</b-button
              >
              <b-button
                @click="saveChange"
                variant="primary"
                class="ml-2"
                :class="{ loading: showSpinnerSend }"
                v-if="listResult.length == 0"
              >
                <template v-if="!showSpinnerSend"
                  >{{ $t("class-calendar.button.2") }}
                </template>
                <b-spinner
                  style="width: 1rem !important; height: 1rem !important"
                  v-else
                  variant="light"
                  label="Spinning"
                ></b-spinner>
              </b-button>

              <b-button
                v-else
                @click="saveChangeValidar"
                variant="primary"
                class="ml-2"
                :class="{ loading: showSpinnerSend }"
              >
                <template v-if="!showSpinnerSend"
                  >{{ $t("class-calendar.button.3") }}
                </template>
                <b-spinner
                  style="width: 1rem !important; height: 1rem !important"
                  v-else
                  variant="light"
                  label="Spinning"
                ></b-spinner>
              </b-button>
            </div>
          </template>
        </b-modal>
      </div>
      <div>
        <b-modal id="modal-save-change-counter-send-student" :centered="true">
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
          </template>
          <h5 class="bold text-center">
            {{ $t("reusables.student-edited-schedule-3") }}
          </h5>
          <p class="text-center mb-0">
            {{ $t("reusables.student-edited-schedule-4") }}
          </p>
          <template #modal-footer>
            <div class="w-100 d-flex justify-content-center">
              <b-button
                variant="primary"
                @click="$bvModal.hide('modal-save-change-counter-send-student')"
                >{{ $t("reusables.student-edited-schedule-5") }}</b-button
              >
            </div>
          </template>
        </b-modal>
      </div>
      <b-modal
        id="modal-add-event"
        centered
        :title="$t('title.11')"
        @close="closeModal"
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
          <h5>{{ $t("title.11") }}</h5>
        </template>
        <p class="d-flex align-items-center">
          <i class="material-icons-outlined mr-3">bookmark</i>
          <span>{{ $t("reusables.test-class") }}</span>
        </p>
        <p class="d-flex align-items-center">
          <span class="material-icons-outlined mr-3">schedule</span>
          <span>{{
            this.eventCreated != null
              ? getFormatDate(
                  this.eventCreated.startStr,
                  this.eventCreated.endStr,
                  this.lang,
                  flagPlanTest,
                  maximoHorasCalendario
                )
              : ""
          }}</span>
        </p>
        <div>
          <b-alert
            show
            variant="danger"
            style="padding: 5px; font-size: 0.7rem; text-align: center"
            v-if="showAlertModal"
            >{{ message }}</b-alert
          >
        </div>
        <template #modal-footer>
          <b-button variant="danger" @click="closeModal">
            {{ $t("horario.buttons.cancel") }}
          </b-button>
          <b-button @click="saveEvent" variant="primary">
            <template v-if="!showSpinnerSaveSchedule">{{
              $t("horario.buttons.save")
            }}</template>
            <b-spinner
              style="width: 1rem !important; height: 1rem !important"
              v-else
              variant="success"
              label="Spinning"
            ></b-spinner>
          </b-button>
        </template>
      </b-modal>
      <!--MODAL CON INFORMACION DE LA CLASE-->
      <b-modal
        id="modal-class-info"
        centered
        @close="closeModalRemove"
        :hide-footer="
          !(
            infoClass.stateClass &&
            !arrStatusNotEditableLinkClass.includes(infoClass.stateClass)
          )
        "
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
          <h5>{{ $t("horario.modal-notes.text-4") }}</h5>
        </template>
        <p
          class="d-flex align-items-center"
          v-if="infoClass.stateClass != null"
        >
          <i class="material-icons-outlined mr-3">query_stats</i>
          <span style="font-weight: 600" :style="{ color: infoClass.color }">{{
            infoClass.stateClassName
          }}</span>
        </p>
        <p class="d-flex align-items-center">
          <i class="material-icons-outlined mr-3">account_circle</i>
          <span>{{ infoClass.personTeacherName }}</span>
        </p>
        <p class="d-flex align-items-center">
          <i class="material-icons-outlined mr-3">schedule</i>
          <span>{{
            infoClass != null
              ? getFormatDateComplete(
                  infoClass.startDate,
                  infoClass.endDate,
                  this.lang,
                  flagPlanTest,
                  maximoHorasCalendario
                )
              : ""
          }}</span>
        </p>
        <p class="d-flex align-items-center" v-if="flagPlanTest">
          <i class="material-icons-outlined mr-3">quiz</i>
          <span>{{ $t("horario.calendario.plan-test") }}</span>
        </p>
        <p class="d-flex align-items-center">
          <i class="material-icons-outlined mr-3">class</i>
          <span style="white-space: pre-line">{{
            infoClass.subjectsName
          }}</span>
        </p>
        <p class="d-flex align-items-center">
          <i class="material-icons-outlined mr-3">link</i>
          <span style="word-break: break-all">{{
            infoClass.linkClass ? infoClass.linkClass : "-"
          }}</span>
        </p>
        <div>
          <b-alert
            show
            variant="danger"
            style="padding: 5px; font-size: 0.7rem; text-align: center"
            v-if="showAlertModal"
            >{{ message }}</b-alert
          >
        </div>
        <b-alert show variant="danger" v-if="messageResult">{{
          messageResult
        }}</b-alert>
        <template
          #modal-footer
          v-if="
            infoClass.stateClass &&
            !arrStatusNotEditableLinkClass.includes(infoClass.stateClass)
          "
        >
          <template v-if="infoClass.stateClass != '3'">
            <!--<b-button variant="link" @click="closeModalRemove">{{$t('horario.buttons.cancel')}}</b-button>-->

            <b-button
              v-b-modal.modal-schedule-cancel-student
              v-show="isRepresentative && !flagPlanTest"
              variant="danger"
            >
              <template v-if="!showSpinnerSave">
                {{ $t("horario.buttons.cancel-classes") }}
              </template>
              <b-spinner
                style="width: 1rem !important; height: 1rem !important"
                v-else
                variant="light"
                label="Spinning"
              ></b-spinner>
            </b-button>

            <b-button
              variant="primary"
              @click="viewClass(infoClass.linkClass)"
              :disabled="!infoClass.linkClass"
            >
              <icon name="video" aria-hidden="true"></icon>
              {{ $t("horario.modal-notes.button-enter-zoom") }}
            </b-button>
          </template>
        </template>
      </b-modal>
      <b-modal
        id="modal-schedule-cancel-student"
        :hide-footer="false"
          :hide-header="false"
          :hide-body="true"
          :centered="true"
          :no-close-on-esc="true"
      >
        <template #modal-header="{ close }">
          <img
            class="close" 
            src="@/assets/img/close_red.png"
            @click="close()"
          />
        </template>
        <p class="text-center mb-0"> 
          {{!flaganticipation? $t("modals.modalViewSchedule.modal-schedule-cancel.titulo-1") : $t("modals.modalViewSchedule.modal-schedule-cancel.titulo-1-b", {HRS:nroHoursAnticipationLessonCancel})}}
        </p>   
        <template #modal-footer>
          <b-button
            variant="danger"
            @click="$bvModal.hide('modal-schedule-cancel-student')"
            >{{
              $t("modals.modalViewSchedule.modal-schedule-cancel.button-Goback")
            }}</b-button
          >
          <b-button @click="cancelClass" variant="primary">
            <template v-if="!showSpinnerCancel">{{
              $t("modals.modalViewSchedule.modal-schedule-cancel.button-Accept")
            }}</template>
            <b-spinner
              style="width: 1rem !important; height: 1rem !important"
              v-else
              variant="light"
              label="Spinning"
            ></b-spinner>
          </b-button>
        </template>
      </b-modal>

      <b-modal id="modal-not-edit" :centered="true">
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
          <h5 style="text-align: center">
            {{ $t("horario.calendario.text.6") }}
          </h5>
        </template>

        <template #modal-footer>
          <b-button @click="$bvModal.hide('modal-not-edit')" variant="primary">
            {{ $t("modals.modalViewSchedule.modal-schedule-cancel.button") }}
          </b-button>
        </template>
      </b-modal>

      <b-modal
        id="modalTeacher"
        ref="modalTeacher"
        :hide-footer="true"
        :hide-header="true"
        :centered="true"
      >
        <img
          class="close"
          src="@/assets/img/close_red.png"
          @click="$bvModal.hide('modalTeacher')"
        />
        <h6 class="sub-title">
          <span>{{ $t("dashboard.modal-changue-teacher.titulo") }}</span>
        </h6>
        <p class="text-center" v-if="groupsPlan">
          {{
            $t("dashboard.modal-changue-teacher.text", {
              NRO: groupsPlan.limitTeacherChanges,
            })
          }}
        </p>
        <ul class="mt-4 list-ul pl-3 pr-3" v-if="teacherChangesInfo">
          <li>
            {{
              $t("dashboard.modal-changue-teacher.options.1", {
                NRO: teacherChangesInfo.quantityTeacherChanges,
                VEZ:
                  teacherChangesInfo.quantityTeacherChanges == 1
                    ? $t("reusables.time")
                    : $t("reusables.times"),
                QUEDA:
                  teacherChangesInfo.quantityTeacherChanges == 1
                    ? $t("reusables.queda")
                    : $t("reusables.quedan"),
                NRO2:
                  groupsPlan.limitTeacherChanges -
                  teacherChangesInfo.quantityTeacherChanges,
                S:
                  groupsPlan.limitTeacherChanges -
                    teacherChangesInfo.quantityTeacherChanges ==
                  1
                    ? ""
                    : "s",
              })
            }}
          </li>
          <li>{{ $t("dashboard.modal-changue-teacher.options.2") }}</li>
        </ul>

        <div></div>
        <div class="card card-body mb-4 mt-4" v-if="teacher && teacher.person">
          <!-- <b-avatar variant="info" :src="teacher.person.photo"></b-avatar> -->
          <b-avatar
            v-if="teacher && teacher.person"
            variant="light"
            :src="teacher.person.photo ? teacher.person.photo : urlPhoto"
            class="mr-4"
          ></b-avatar>
          <div class="ml-3">
            <p class="mb-0">
              {{ $t("dashboard.modal-changue-teacher.card.text") }}
            </p>
            <h6>
              <span class="spanSubTitle">{{ teacher.person.strFullName }}</span>
            </h6>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-primary d-block m-auto"
          :disabled="
            groupsPlan.limitTeacherChanges -
              teacherChangesInfo.quantityTeacherChangess ==
            0
          "
          @click="$bvModal.show('modalConfirmTeacher')"
        >
          <template>{{
            $t("dashboard.modal-changue-teacher.card.continue")
          }}</template>
        </button>
        <!--
                <button type="button" class="btn btn-primary  d-block m-auto" :disabled="groupsPlan.limitTeacherChanges - teacherChangesInfo.quantityTeacherChanges == 0" @click="changueTeacherMethod">
                    <span v-if="!showSpinnerChange" style="color:#ffffff;">{{$t('dashboard.modal-changue-teacher.card.continue')}}</span>
                <b-spinner
                  style="width: 1rem !important; height: 1rem !important ;"
                  v-else
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                  </button>-->
      </b-modal>

      <b-modal
        v-model="modalConfirmTeacher"
        id="modalConfirmTeacher"
        :hide-footer="true"
        :hide-header="true"
      >
        <h6 class="sub-title">
          <span>{{ $t("modals.modalConfirm.text-7") }}</span>
        </h6>
        <div class="d-block text-right">
          <button
            class="btn btn-danger mr-3"
            style="display: initial"
            @click="$bvModal.hide('modalConfirmTeacher')"
          >
            {{ $t("modals.modalConfirm.button-cancel") }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="
              groupsPlan.limitTeacherChanges -
                teacherChangesInfo.quantityTeacherChanges ==
              0
            "
            @click="changueTeacherMethod"
          >
            <span v-if="!showSpinnerChange" style="color: #ffffff">{{
              $t("modals.modalConfirm.button")
            }}</span>
            <b-spinner
              style="width: 1rem !important; height: 1rem !important"
              v-else
              variant="light"
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>

      <b-modal id="modal-next-linkClass" :centered="true">
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
        </template>
        <p class="text-center mb-0">{{ messageLinkClassResult }}</p>
        <template #modal-footer>
          <b-button
            @click="$bvModal.hide('modal-next-linkClass')"
            variant="primary"
            >Aceptar</b-button
          >
        </template>
      </b-modal>
      <b-modal
        id="modal-validate-save-change-counter-student"
        :centered="true"
        :no-close-on-esc="true"
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
        </template>
        <p class="text-center mb-0">
          {{ message }}
        </p>
        <template #modal-footer>
          <b-button
            variant="primary"
            @click="
              $bvModal.hide('modal-validate-save-change-counter-student'),
                $bvModal.hide('modal-save-change')
            "
          >
            <template v-if="!showSpinnerSend">{{
              $t("reusables.buttonProgramaMasAdelante")
            }}</template>
            <b-spinner
              style="width: 1rem !important; height: 1rem !important"
              v-else
              variant="light"
              label="Spinning"
            ></b-spinner>
          </b-button>
          <b-button variant="danger" @click="saveChangeConfirm">
            {{ $t("reusables.buttonProgramaAhora") }}</b-button
          >
        </template>
      </b-modal>
      <!--MODAL CRUCE CLASES DE PROPUESTA -->
      <b-modal
        id="modal-validate-cross"
        :centered="true"
        body-class="pt-2"
        footer-class="justify-content-center"
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
        </template>
        <p class="text-center mb-0">
          {{ $t("reusables.student-edited-schedule-16") }}
        </p>
        <template #modal-footer>
          <b-button
            variant="danger"
            @click="$bvModal.hide('modal-validate-cross')"
            >{{ $t("reusables.cancel") }}</b-button
          >
        </template>
      </b-modal>
      <!-- ------- -->
    </div>
    <!--:key="`class-modal-schedule-2`"-->
    <viewSchedule
      :showActions="false"
      @updateSchedule="updateListStrudent"
      ref="viewScheduleEditModal"
      @value="getShowModalPerson = $event"
      @listenTeacherInfoComments="getTeacherInformationAndComments"
    />
    <modalTeacher :teacherInformation="teacherInformation" :flagEdit="false" />
    <modalChangeTimeZone @updateCalendar="reloadData()" />
  </div>
</template>
<script>
import CustomSelect from "@/components/form/select";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import * as Constants from "@/assets/js/appConstants";
import modalTeacher from "@/components/modals/commentary";
import {
  redirectHorario,
  horarioObtenerColorClaseConsolidado,
  getCalendarHeaderFormat,
  getCalendarTitle,
  getFormatDate,
  getFormatDateComplete,
  getFormatDateCompleteTitle,
  getFormatDateCompleteTitleTime,
  getFormatDateCompleteClass,
  getFormatDateCompleteDetail,
  getCalendarEventTimeFormat,
  getCalendarHeaderToolbar,
  openLinkClass,
  horarioObtenerNameClaseEnEsConsolidado,
  getNextClassDate,
  getNextClassTime,
  convertToUserTimeCalendarEvents,
  getHoursByTimeZoneName,
  convertTimeToUserTime,
  convertTimeToUserTimeFormat,
  convertTimeCalendarEvents,
  convertTimeToUTC,
  ValidarMergeHorarios,
  ValidarMergeHorariosByRecurrent,
} from "@/assets/js/util.js";
import viewSchedule from "@/components/modals/view-schedule-edit";
import modalChangeTimeZone from "@/components/modals/ModalChangeTimeZone";
import { required } from "vuelidate/lib/validators";
import { validationMessage } from "vuelidate-messages";

let eventGuid = 0;
export function createEventId() {
  return String(eventGuid++);
}

const formUpdateDateMessages = {
  requiredFecha: function () {
    return this.$t("reusables.obligatoryField");
  },
  requiredTypeClass: function () {
    return this.$t("reusables.obligatoryField");
  },
  requiredStartDate: function () {
    return this.$t("reusables.obligatoryField");
  },
};

export default {
  components: {
    viewSchedule,
    FullCalendar,
    modalTeacher,
    CustomSelect,
    modalChangeTimeZone,
  },
  props: {
    backStep: {
      type: Function,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      flagPlanTestEdit: false,
      flagCancelClass: false,
      urlPhoto: Constants.IMAGENES.PHOTO_TEACHER_DEFAULT,
      messageResult: null,
      messageLinkClassResult: null,
      dateStartValidate: null,
      dateEndValidate: null,
      dateStartValidateNext: null,
      dateEndValidateNext: null,
      showSpinnerCancel: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      selectTimeInit: 0,
      daysMaxSchedule: 0,
      maximoHorasCalendario: 0,
      flagShowHeader: true,
      lang: localStorage.getItem("lang") || "es",
      showSpinnerSasve: false,
      teacher: {},
      groupsPlan: {},
      expiryWarningDismissed: false,
      expiryWarningDays: 30,
      teacherChangesInfo: {},
      showSpinnerChange: false,
      arrayEditableSchedule: [],
      groupsScheduleProposalEditedId: null,
      groupScheduleStrundetId: null,
      showEditSchedule: false,
      isResponseReceived: false,
      proposalId: null,
      showSpinnerSend: false,
      personTeacherId: 0,
      arrayCalendarChange: [],
      showReadonly: null,
      disabledDate: true,
      minDate: null,
      maxDate: null,
      GroupId: 0,
      SelectBeginningDateChange: new Date(),
      SelectBeginningDateInit: new Date(),
      SelectBeginningDate: new Date(),
      arrayCalendarInit: [],
      showSelectWeek: true,
      uniqDateEnabled: [],
      showLoadingCalendar: false,
      uniqDate: [],
      optionsTime: [],
      optionsClassDelete: [],
      optionsClassRegister: [],
      selectedTime: null,
      nroHoursAnticipationLessonCancel: 0,
      showSpinnerSaveSchedule: false,
      flaganticipation: false,
      nroClaseCancelarSemana: 0,
      flagEdit: false,
      flagPlanTest: false,
      showLoadingFirst: true,
      nextDateClass: null,
      nextClass: null,
      dataTeacher: {},
      infoClass: {},
      showSpinnerSave: false,
      message: "",
      titleCourse: "",
      eventCreated: null,
      showLoading: false,
      showAlertModal: false,
      listCalendar: [],
      formatDay: "DD",
      new_appointment: {
        title: null,
        description: null,
      },
      calendarOptions: {
        customButtons: {
          today: {
            text: `${this.$t("reusables.today")}`,
            click: () => {
              this.selectedTime = this.selectTimeInit;
              let calendarApi = this.$refs.fullCalendarStudent.getApi();
              calendarApi.gotoDate(new Date());
            },
          },
          prev: {
            text: "PREV",
            click: () => {
              this.selectedTime--;
              let calendarApi = this.$refs.fullCalendarStudent.getApi();
              calendarApi.prev();
            },
          },
          next: {
            text: "NEXT",
            click: () => {
              this.selectedTime++;
              let calendarApi = this.$refs.fullCalendarStudent.getApi();
              calendarApi.next();
            },
          },
        },
        fixedWeekCount: true,
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        events: [],
        eventOverlap: false,
        themeSystem: "bootstrap",
        nowIndicator: true,
        firstDay: 1,
        headerToolbar: getCalendarHeaderToolbar(this.flagShowHeader),
        buttonText: {
          today: this.$t("reusables.today"),
        },
        titleFormat: function (date) {
          return getCalendarTitle(date.date, this.lang);
        },
        height: "auto",
        allDaySlot: false,
        viewDidMount: (view) => {
          let GMT = getHoursByTimeZoneName(
            this.$moment,
            this.$store.state.user.timeZoneName
          );
          view.el.querySelector(".fc-timegrid-axis-frame").innerHTML = GMT;
          view.el
            .querySelector(".fc-timegrid-axis-frame")
            .addEventListener("click", () => {
              this.$bvModal.show("modal-change-time-zone");
            });
        },
        initialView: "timeGridWeek",
        dayHeaderContent: (args) => {
          return getCalendarHeaderFormat(
            this.$moment,
            args.date,
            this.lang,
            this.formatDay
          );
        },
        eventTimeFormat: getCalendarEventTimeFormat(),
        initialEvents: [], //INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: false,
        scrollTimeReset: false,
        isLoading: true,
        eventColor: Constants.CALENDAR_STATUS.CONFIRM.COLOR,
        selectable: false,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventResizableFromStart: false,
        select: this.handleDateSelect,
        selectAllow: this.handleSelecAllow,
        eventChange: this.handleEvents,
        //eventClick: this.handleEventClick,
        //eventDrop: this.eventDrop,
        //eventDragStop: this.eventDrop,
      },
      hideButtonsForEdit: false,
      teacherInformation: null,
      getFormatDate: getFormatDate,
      getFormatDateComplete: getFormatDateComplete,
      getFormatDateCompleteTitle: getFormatDateCompleteTitle,
      getFormatDateCompleteTitleTime: getFormatDateCompleteTitleTime,
      getFormatDateCompleteDetail: getFormatDateCompleteDetail,
      getFormatDateCompleteClass: getFormatDateCompleteClass,
      openLinkClass: openLinkClass,
      linkClass: "",
      arrStatusNotEditableLinkClass: [
        Constants.CALENDAR_STATUS.COMPLETED.VALUE,
        Constants.CALENDAR_STATUS.CANCELED_TEACHER.VALUE,
        Constants.CALENDAR_STATUS.CANCELED_STUDENT.VALUE,
        Constants.CALENDAR_STATUS.PENDING_REPORT.VALUE,
        Constants.CALENDAR_STATUS.UNATTENDANCE_STUDENT.VALUE,
        Constants.CALENDAR_STATUS.UNATTENDANCE_TEACHER.VALUE,
        Constants.CALENDAR_STATUS.FROZEN.VALUE,
      ],
      TYPE_SCHEDULE: Constants.TYPE_SCHEDULE,
      ARRAY_DIA_SEMANA: Constants.DIA_SEMANA,
      formatDate:
        (localStorage.getItem("lang") || "es") == "es"
          ? "DD/MM/YYYY"
          : "MM/DD/YYYY",
      modalConfirmTeacher: false,
      formatDateSchedule: "YYYY-MM-DDTHH:mm:ss",
      infoEventoDelete: {
        startDate: null,
        endDate: null,
      },
      infoEventoRegister: {
        startDate: null,
        endDate: null,
      },
      classRegister: {
        id: "",
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        isNew: false,
      },
      classDelete: {
        id: 0,
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        isDelete: false,
      },
      eventDelete: null,
      eventRegister: null,
      listClassDelete: [],
      listClassRegister: [],
      classDeleteTimeClass: " ",
      messageAddClass: "",
      listRecurrent: [],
      flagChange: false,
      listResult: [],
    };
  },
  validations: {
    classRegister: {
      typeClass: {
        requiredTypeClass(value) {
          return !(value === "" || value == null);
        },
      },
    },
    classDelete: {
      typeClass: {
        requiredTypeClass(value) {
          return !(value === "" || value == null);
        },
      },
    },
  },
  async created() {
    this.GroupId = this.$store.state.group_id;
    this.getDataPlan();

    redirectHorario(
      this.$store.state.datosSidebar.typeScheduled,
      this,
      this.$store.state.is_representative
    );
    if (
      this.$store.state.datosSidebar.typeScheduled ==
      Constants.TYPE_SCHEDULED.SCHEDULED
    ) {
      this.getDateMinMax(new Date());

      this.showLoadingFirst = true;

      await this.getCourses();

      this.getListScheduleClass();
      this.getDashboardData();
    }
  },
  mounted() {},
  methods: {
    isFutureEvent(start) {
      const now = this.$moment();
      return this.$moment(start).isAfter(now);
    },
    reloadData() {
      this.getListScheduleClass();
      this.getDashboardData();
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    getDataPlan() {
      let data = {
        GroupId: this.GroupId,
      };
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupsCoursesLessons/EntitySchedulePlanTest`,
          {
            params: data,
          }
        )
        .then((response) => {
          if (response.data.entity) {
            this.maximoHorasCalendario =
              response.data.entity.maximoHorasCalendario;
            this.flagPlanTest = response.data.entity.flagPlanTest;
            this.daysMaxSchedule = response.data.entity.daysMaxSchedule + 1;
            this.flagShowHeader = true;
            // this.formatDay = ' '
            if (response.data.entity.flagPlanTest) {
              this.flagShowHeader = false;
              //this.formatDay = 'DD'
              this.maximoHorasCalendario =
                response.data.entity.durationClassTest / 60;

              /*this.calendarOptions.validRange = {
                  start: this.$moment().format('YYYY-MM-DD'),
                  end: this.$moment().add(this.daysMaxSchedule, 'days').format('YYYY-MM-DD'),
                };*/
            } else {
              /*this.calendarOptions.validRange = {
                  start: null,
                  end: null,
                };*/
            }

            this.calendarOptions.headerToolbar = getCalendarHeaderToolbar(
              this.flagShowHeader
            );
          }
        });
    },
    openLinkClassLocal(linkClass) {
      this.messageLinkClassResult = null;
      let result = openLinkClass(
        linkClass,
        this.$moment,
        this.dateStartValidateNext,
        this.dateEndValidateNext,
        this.$store.state.user.timeZoneName
      );
      if (result != "") {
        this.messageLinkClassResult = result;
        this.$bvModal.show("modal-next-linkClass");
      }
    },
    viewClass(urlClass) {
      let result = openLinkClass(
        urlClass,
        this.$moment,
        this.dateStartValidate,
        this.dateEndValidate,
        this.$store.state.user.timeZoneName
      );
      if (result != "") {
        this.messageResult = result;
      }
    },
    getDashboardData() {
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/dashboard/GetStudentConsolidatedById?personStudentId=${this.$store.state.user.personStudentId}`
        )

        .then((response) => {
          if (response.data != null && response.data.entity != null) {
            this.groupsPlan = response.data.entity.groupsPlan;

            if (this.groupsPlan != null) {
              if (response.data.entity.flagTeacher) {
                this.teacher = response.data.entity.personsTeachers;
              }
            }
          }
        });
    },
    getTeacherChanges: function () {
      var datos = {
        id: this.groupsPlan.id,
      };
      baseInstanceAxios
        .post(
          `${this.apiURL}/resources/Dashboard/GetQuantityGroupsPlanTeacherChanges`,
          datos
        )
        .then((response) => {
          if (response.data != null && response.data.entity != null) {
            this.teacherChangesInfo = response.data.entity;
            this.$bvModal.show("modalTeacher");
          }
        });
    },

    updateListStrudent() {
      this.reply();
    },

    modalSchedule() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    this.$nextTick(() => {        
      document.body.classList.add("modal-open"); // Desactiva el scroll
      document.documentElement.classList.add("modal-open"); // Asegura que no haya scroll global
      document.querySelector(".content-main")?.classList.add("hide-background"); // Oculta el fondo
      document.querySelector(".content-main")?.classList.add("push-down");
    });  
      this.$refs.viewScheduleEditModal.showModalEditStudent(
        true,
        this.dataTeacher,
        this.groupsScheduleProposalEditedId,
        this.flagPlanTest,
        this.groupsPlan,
        this.personTeacherId,
        this.dataGroup
      );
    },
    changueTeacherMethod() {
      this.showSpinnerChange = true;
      let data = {
        ScheduleId: this.groupScheduleStrundetId,
        groupId: this.$store.state.group_id,
        Usuario: this.$store.state.user.email,
        //BeginningDate: this.SelectBeginningDateChange
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupsCoursesLessons/SaveScheduleTeacherChanges`,
          { params: data }
        )
        .then((response) => {
          try {
            if (this.teacher && this.teacher.id) {
              sessionStorage.setItem(
                "pendingTeacherReview",
                JSON.stringify({
                  personTeacherId: this.teacher.id,
                  nameTeacher: this.teacher.person
                    ? this.teacher.person.strFullName
                    : "",
                })
              );
            }
          } catch (e) {
            /* ignore storage errors */
          }
          this.$store.state.datosSidebar.typeScheduled = 1;
          this.$store.state.datosSidebar.flagEdited = true;
          this.$router.push({ path: "/horario/calendario/public" });
          this.showSpinnerChange = false;
          this.$bvModal.hide("modalConfirmTeacher");
        })
        .catch((err) => {
          this.showSpinnerSave = false;
          this.message = this.$t("horario.error-changing-teacher");

          this.$bvToast.show("toast-equis-modal-calendar-class");
          this.$bvModal.hide("modalConfirmTeacher");
        });
    },
    getDateMinMax(minDateArray) {
      this.minDate = new Date(minDateArray);

      let d = new Date(minDateArray),
        diff = d.getDate() + 7; //TODO:Validar param
      this.maxDate = new Date(d.setDate(diff));
    },
    async saveChange() {
      if (this.groupsPlan != null && this.groupsPlan.flagPlanTest) {
        this.saveChangeConfirm();
      } else {
        this.listResult = [];
        this.showSpinnerSend = true;
        let arraySchedule = [];

        let arraySend = this.listCalendar.filter((currentValue) => {
          return currentValue.request;
        });

        arraySend.forEach((element) => {
          let json = {
            StartDate: this.$moment(element.StartDate).format(
              this.formatDateSchedule
            ),
            EndDate: this.$moment(element.EndDate).format(
              this.formatDateSchedule
            ),
            StateClassId: parseInt(Constants.CALENDAR_STATUS.CONFIRM.VALUE),
            IsNew: element.isNew,
            NoRecurrent:
              element.noRecurrent === undefined || element.noRecurrent === false
                ? false
                : true,
          };
          arraySchedule.push(json);
        });
        let arrayDelete = this.listClassDelete.map((item) => {
          return {
            ...item,
            StartDate: this.$moment(item.startDate).format(
              this.formatDateSchedule
            ),
            EndDate: this.$moment(item.endDate).format(this.formatDateSchedule),
          };
        });
        this.SelectBeginningDate = new Date();
        let jsonData = {
          Schedule: {
            id: this.proposalId,
            BeginningDate: this.SelectBeginningDate,
          },
          ScheduleDetail: arraySchedule.concat(
            arrayDelete.filter(
              (item) =>
                item.id > 0 &&
                (item.isNew === undefined || item.isNew === false)
            )
          ),
          UserMail: this.$store.state.user.email,
        };

        convertTimeCalendarEvents(
          jsonData.ScheduleDetail,
          this.$store.state.user.timeZoneName,
          this.$moment
        );
        jsonData.TimeZoneName = this.$store.state.user.timeZoneName;
        await baseInstanceAxios
          .post(
            `${this.apiURL}/resources/GroupScheduleCounterProposal/ValidateSaveEditionScheduleByTimeExceed`,
            jsonData
          )
          .then((response) => {
            this.showSpinnerSend = false;
            this.showLoadingCalendar = false;
            if (response.data.entity != null) {
              this.listResult = response.data.entity.scheduleDetail;
              if (this.listResult.length > 0) {
                this.calendarOptions.events.forEach((event) => {
                  if (event.editable && !(event.noRecurrent === false)) {
                    let isInList = this.listResult.find(
                      (item) =>
                        item.startDate === event.start &&
                        item.endDate === event.end
                    );
                    event.isInList = isInList != undefined;
                  } else {
                    event.isInList = false;
                  }
                });
              }
            } else {
              this.saveChangeValidar();
            }
          })
          .catch((error) => {
            this.message = this.$t("error.error-saving-changes");
            this.$bvToast.show("toast-equis-modal-calendar-class");
            this.showSpinnerSend = false;
          });
      }
    },
    saveChangeValidar() {
      this.showSpinnerSend = true;
      let arraySchedule = [];

      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });

      arraySend.forEach((element) => {
        let json = {
          StartDate: this.$moment(element.StartDate).format(
            this.formatDateSchedule
          ),
          EndDate: this.$moment(element.EndDate).format(
            this.formatDateSchedule
          ),
          StateClassId: parseInt(Constants.CALENDAR_STATUS.CONFIRM.VALUE),
          IsNew: element.isNew,
          NoRecurrent:
            element.noRecurrent === undefined || element.noRecurrent === false
              ? false
              : true,
        };
        arraySchedule.push(json);
      });
      let arrayDelete = this.listClassDelete.map((item) => {
        return {
          ...item,
          StartDate: this.$moment(item.startDate).format(
            this.formatDateSchedule
          ),
          EndDate: this.$moment(item.endDate).format(this.formatDateSchedule),
        };
      });
      this.SelectBeginningDate = new Date();
      let jsonData = {
        Schedule: {
          id: this.proposalId,
          BeginningDate: this.SelectBeginningDate,
        },
        ScheduleDetail: arraySchedule.concat(
          arrayDelete.filter(
            (item) =>
              item.id > 0 && (item.isNew === undefined || item.isNew === false)
          )
        ),
        UserMail: this.$store.state.user.email,
      };

      convertTimeCalendarEvents(
        jsonData.ScheduleDetail,
        this.$store.state.user.timeZoneName,
        this.$moment
      );

      baseInstanceAxios
        .post(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/ValidateSaveEditionSchedule`,
          jsonData
        )
        .then((response) => {
          this.showSpinnerSend = false;
          this.showLoadingCalendar = false;
          if (response.data != null) {
            if (
              response.data.valueDecimal == 0 &&
              response.data.return == false
            ) {
              this.$bvModal.show("modal-validate-cross");
              this.$bvModal.hide("modal-save-change");
            } else {
              if (response.data.valueDecimal > 0) {
                this.message = this.$t("reusables.student-edited-schedule-14", {
                  NRO: response.data.valueDecimal.toString(),
                });
                this.$bvModal.show(
                  "modal-validate-save-change-counter-student"
                );
              } else {
                this.saveChangeConfirm();
              }
            }
          }
        })
        .catch((error) => {
          this.message = this.$t("error.error-saving-changes");
          this.$bvToast.show("toast-equis-modal-calendar-class");
          this.showSpinnerSend = false;
        });
    },
    saveChangeConfirm() {
      this.showLoadingCalendar = true;
      this.$bvModal.hide("modal-validate-save-change-counter-student");
      this.showSpinnerSend = true;
      let arraySchedule = [];

      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });

      arraySend.forEach((element) => {
        let json = {
          StartDate: this.$moment(element.StartDate).format(
            this.formatDateSchedule
          ),
          EndDate: this.$moment(element.EndDate).format(
            this.formatDateSchedule
          ),
          StateClassId: parseInt(Constants.CALENDAR_STATUS.CONFIRM.VALUE),
          IsNew: element.isNew,
          NoRecurrent:
            element.noRecurrent === undefined || element.noRecurrent === false
              ? false
              : true,
        };
        arraySchedule.push(json);
      });
      let arrayDelete = this.listClassDelete.map((item) => {
        return {
          ...item,
          StartDate: this.$moment(item.startDate).format(
            this.formatDateSchedule
          ),
          EndDate: this.$moment(item.endDate).format(this.formatDateSchedule),
        };
      });
      this.SelectBeginningDate = new Date();
      let jsonData = {
        Schedule: {
          id: this.proposalId,
          BeginningDate: this.SelectBeginningDate,
        },
        ScheduleDetail: arraySchedule.concat(
          arrayDelete.filter(
            (item) =>
              item.id > 0 && (item.isNew === undefined || item.isNew === false)
          )
        ),
        UserMail: this.$store.state.user.email,
      };

      convertTimeCalendarEvents(
        jsonData.ScheduleDetail,
        this.$store.state.user.timeZoneName,
        this.$moment
      );

      baseInstanceAxios
        .post(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/SaveEditionSchedule`,
          jsonData
        )
        .then((response) => {
          let value = response.data.value;

          if (value == -3) {
            this.message = this.$t("reusables.student-edited-schedule-15");
            this.$bvToast.show("toast-equis-modal-request-class-student");
          } else if (value == -2 || value == 0) {
            this.message = this.$t("reusables.empty-filtered-text");
            this.$bvToast.show("toast-equis-modal-request-class-student");
          } else if (value > 0) {
            this.message = this.$t("valid.changes-saved-correctly");
            this.$bvModal.hide("modal-save-change");
            this.$bvModal.show("modal-save-change-counter-send-student");
            this.reply();
          }
          this.showSpinnerSend = false;
          this.showLoadingCalendar = false;
        })
        .catch((error) => {
          this.message = this.$t("error.error-saving-changes");
          this.$bvToast.show("toast-equis-modal-calendar-class");
          this.showSpinnerSend = false;
        });
    },
    saveChangeDelete() {
      this.showSpinnerSend = true;
      let arrayDelete = this.listClassDelete.map((item) => {
        return {
          ...item,
          StartDate: this.$moment(item.startDate).format(
            this.formatDateSchedule
          ),
          EndDate: this.$moment(item.endDate).format(this.formatDateSchedule),
        };
      });
      let jsonData = {
        Schedule: {
          id: 0,
        },
        ScheduleDetail: arrayDelete.filter(
          (item) =>
            item.id > 0 && (item.isNew === undefined || item.isNew === false)
        ),
        UserMail: this.$store.state.user.email,
      };

      convertTimeCalendarEvents(
        jsonData.ScheduleDetail,
        this.$store.state.user.timeZoneName,
        this.$moment
      );

      baseInstanceAxios
        .post(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/SaveEditionSchedule`,
          jsonData
        )
        .then((response) => {
          this.message = this.$t("valid.changes-saved-correctly");
          this.$bvToast.show("toast-check-modal-calendar-class");
          this.showSpinnerSend = false;
          this.flagCancelClass = false;
          this.showLoadingCalendar = true;
          this.reply();
        })
        .catch((error) => {
          this.message = this.$t("error.error-saving-changes");
          this.$bvToast.show("toast-equis-modal-calendar-class");
          this.flagCancelClass = false;
          this.showSpinnerSend = false;
        });
    },
    removeEvent(event) {
      if (this.groupsPlan != null && this.groupsPlan.flagPlanTest) {
        this.removeEventPlanTest(event);
      } else {
        let eventCurrent = this.calendarOptions.events.find((currentValue) => {
          return parseInt(currentValue.id) == event.id && currentValue.isNew;
        });
        this.eventDelete = event;
        if (eventCurrent == undefined) {
          this.GetScheduleByDelete(event);
        } else {
          this.classDelete.isNew = true;
          this.SaveClassDeleteByNew(event, eventCurrent.noRecurrent);
        }
      }
    },
    removeEventPlanTest(event) {
      this.arrayCalendarChange = this.arrayCalendarChange.filter(function (e) {
        return (
          new Date(e.StartDate).getTime() !=
            new Date(event.startStr).getTime() &&
          new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
        );
      });
      this.listCalendar = this.listCalendar.filter(function (e) {
        return (
          new Date(e.StartDate).getTime() !=
            new Date(event.startStr).getTime() &&
          new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
        );
      });
      this.calendarOptions.events = this.calendarOptions.events.filter(
        function (e) {
          return (
            new Date(e.start).getTime() != new Date(event.startStr).getTime() &&
            new Date(e.end).getTime() != new Date(event.endStr).getTime()
          );
        }
      );

      let arrayDateFormat = [];
      if (this.arrayCalendarChange.length > 0) {
        this.disabledDate = false;
        this.getDateMinMax(new Date());
      } else {
        this.disabledDate = true;
        this.SelectBeginningDate = new Date();
      }

      event.remove();
    },
    SaveClassDeleteByNew(event, noRecurrent) {
      this.classDelete.id = event.id;
      this.infoEventoDelete.startDate = event.start;
      this.infoEventoDelete.endDate = event.end;
      this.idValueSelectEventSelectedTimeClassDelete(event);
      if (!noRecurrent) {
        this.$bvModal.show("delete-recurring-class");
      } else {
        this.$bvModal.show("modal-delete-class");
      }
    },
    SaveClassDeleteByNewConfirm(event, noRecurrent) {
      if (noRecurrent) {
        this.arrayCalendarChange = this.arrayCalendarChange.filter(function (
          e
        ) {
          return (
            new Date(e.StartDate).getTime() !=
              new Date(event.startStr).getTime() &&
            new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
          );
        });
        this.listCalendar = this.listCalendar.filter(function (e) {
          return (
            new Date(e.StartDate).getTime() !=
              new Date(event.startStr).getTime() &&
            new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
          );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            return (
              new Date(e.start).getTime() !=
                new Date(event.startStr).getTime() &&
              new Date(e.end).getTime() != new Date(event.endStr).getTime()
            );
          }
        );
      } else {
        const eventDayOfWeek = new Date(event.startStr).getDay();
        const eventTimeStart = event.startStr.slice(11, 16);
        const eventTimeEnd = event.endStr.slice(11, 16);
        const eventDate = new Date(event.startStr);
        this.arrayCalendarChange = this.arrayCalendarChange.filter((e) => {
          const eventStartDate = new Date(e.StartDate);
          return !(
            eventStartDate.getDay() === eventDayOfWeek &&
            e.StartDate.slice(11, 16) === eventTimeStart &&
            e.EndDate.slice(11, 16) === eventTimeEnd &&
            e.noRecurrent === false &&
            e.request === true &&
            eventStartDate >= eventDate
          );
        });

        this.listCalendar = this.listCalendar.filter((e) => {
          const eventStartDate = new Date(e.StartDate);
          return !(
            eventStartDate.getDay() === eventDayOfWeek &&
            e.StartDate.slice(11, 16) === eventTimeStart &&
            e.EndDate.slice(11, 16) === eventTimeEnd &&
            e.noRecurrent === false &&
            e.request === true &&
            eventStartDate >= eventDate
          );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => {
            const eventStartDate = new Date(e.start);
            return !(
              eventStartDate.getDay() === eventDayOfWeek &&
              e.start.slice(11, 16) === eventTimeStart &&
              e.end.slice(11, 16) === eventTimeEnd &&
              e.noRecurrent === false &&
              e.request === true &&
              eventStartDate >= eventDate
            );
          }
        );

        // eliminar evento actual
        this.arrayCalendarChange = this.arrayCalendarChange.filter(function (
          e
        ) {
          if (e.noRecurrent === true) {
            return true;
          }
          return (
            new Date(e.StartDate).getTime() !=
              new Date(event.startStr).getTime() &&
            new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
          );
        });
        this.listCalendar = this.listCalendar.filter(function (e) {
          if (e.noRecurrent === true) {
            return true;
          }
          return (
            new Date(e.StartDate).getTime() !=
              new Date(event.startStr).getTime() &&
            new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
          );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            if (e.noRecurrent === true) {
              return true;
            }
            return (
              new Date(e.start).getTime() !=
                new Date(event.startStr).getTime() &&
              new Date(e.end).getTime() != new Date(event.endStr).getTime()
            );
          }
        );
      }
      if (this.arrayCalendarChange.length > 0) {
        this.disabledDate = false;
        this.getDateMinMax(new Date());
      } else {
        this.disabledDate = true;
        this.SelectBeginningDate = new Date();
      }
      event.remove();
      this.classDelete = {
        id: 0,
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        isDelete: false,
      };
      this.classDeleteTimeClass = " ";

      this.$bvModal.hide("delete-recurring-class");
      this.$v.classDelete.$reset();
    },
    SaveClassDelete() {
      this.$v.classDelete.$touch();
      if (this.$v.classDelete.$invalid) {
        return;
      } else {
        const event = this.eventDelete;
        if (
          this.classDelete.isNew != undefined &&
          this.classDelete.isNew == true
        ) {
          this.SaveClassDeleteByNewConfirm(
            event,
            this.classDelete.typeClass === "false" ? false : true
          );
          this.listClassRegister = this.listClassRegister.filter(
            (currentValue) => {
              return (
                currentValue.idx == undefined ||
                !(parseInt(currentValue.idx) == event.id && currentValue.isNew)
              );
            }
          );
        } else {
          if (
            this.eventDelete != null &&
            this.classDelete.typeClass === "false"
          ) {
            const eventDayOfWeek = new Date(event.startStr).getDay();
            const eventTimeStart = event.startStr.slice(11, 16);
            const eventDate = new Date(event.startStr);
            const eventTimeEnd = event.endStr.slice(11, 16);
            this.arrayCalendarChange = this.arrayCalendarChange.filter((e) => {
              const eventStartDate = new Date(e.StartDate);
              return !(
                eventStartDate.getDay() === eventDayOfWeek &&
                e.StartDate.slice(11, 16) === eventTimeStart &&
                e.EndDate.slice(11, 16) === eventTimeEnd &&
                e.noRecurrent === false &&
                e.request === true &&
                eventStartDate >= eventDate
              );
            });
            this.listCalendar = this.listCalendar.filter((e) => {
              const eventStartDate = new Date(e.StartDate);
              return !(
                eventStartDate.getDay() === eventDayOfWeek &&
                e.StartDate.slice(11, 16) === eventTimeStart &&
                e.EndDate.slice(11, 16) === eventTimeEnd &&
                e.noRecurrent === false &&
                e.request === true &&
                eventStartDate >= eventDate
              );
            });
            this.calendarOptions.events = this.calendarOptions.events.filter(
              (e) => {
                const eventStartDate = new Date(e.start);
                return !(
                  eventStartDate.getDay() === eventDayOfWeek &&
                  e.start.slice(11, 16) === eventTimeStart &&
                  e.end.slice(11, 16) === eventTimeEnd &&
                  e.noRecurrent === false &&
                  e.request === true &&
                  eventStartDate >= eventDate
                );
              }
            );

            if (this.arrayCalendarChange.length > 0) {
              this.disabledDate = false;
              this.getDateMinMax(new Date());
            } else {
              this.disabledDate = true;
              this.SelectBeginningDate = new Date();
            }
            this.eventDelete = null;
          } else {
            this.listClassDelete.push(this.classDelete);
            this.arrayCalendarChange = this.arrayCalendarChange.filter(
              function (e) {
                return (
                  new Date(e.StartDate).getTime() !=
                    new Date(event.startStr).getTime() &&
                  new Date(e.EndDate).getTime() !=
                    new Date(event.endStr).getTime()
                );
              }
            );
            this.listCalendar = this.listCalendar.filter(function (e) {
              return (
                new Date(e.StartDate).getTime() !=
                  new Date(event.startStr).getTime() &&
                new Date(e.EndDate).getTime() !=
                  new Date(event.endStr).getTime()
              );
            });
            this.calendarOptions.events = this.calendarOptions.events.filter(
              function (e) {
                return (
                  new Date(e.start).getTime() !=
                    new Date(event.startStr).getTime() &&
                  new Date(e.end).getTime() != new Date(event.endStr).getTime()
                );
              }
            );
          }
          event.remove();
          this.classDelete = {
            id: 0,
            typeClass: null,
            timeClass: null,
            startDate: null,
            endDate: null,
            isDelete: false,
          };
          this.classDeleteTimeClass = " ";

          this.$bvModal.hide("delete-recurring-class");
          this.$v.classDelete.$reset();
        }
      }
    },
    SaveClassDeleteNoRecurrent() {
      var event = this.eventDelete;
      this.arrayCalendarChange = this.arrayCalendarChange.filter(function (e) {
        return (
          new Date(e.StartDate).getTime() !=
            new Date(event.startStr).getTime() &&
          new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
        );
      });
      this.listCalendar = this.listCalendar.filter(function (e) {
        return (
          new Date(e.StartDate).getTime() !=
            new Date(event.startStr).getTime() &&
          new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
        );
      });
      this.calendarOptions.events = this.calendarOptions.events.filter(
        function (e) {
          return (
            new Date(e.start).getTime() != new Date(event.startStr).getTime() &&
            new Date(e.end).getTime() != new Date(event.endStr).getTime()
          );
        }
      );

      if (this.arrayCalendarChange.length > 0) {
        this.disabledDate = false;
        this.getDateMinMax(new Date());
      } else {
        this.disabledDate = true;
      }
      this.listClassDelete.push(this.classDelete);
      event.remove();
      this.eventDelete = null;
      this.classDelete = {
        id: 0,
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        isDelete: false,
      };
      this.$bvModal.hide("modal-delete-class");
    },

    GetScheduleByDelete(event) {
      this.classDeleteTimeClass = " ";
      var startDate = convertTimeToUTC(
        event.start,
        this.$store.state.user.timeZoneName,
        this.$moment
      );
      var endDate = convertTimeToUTC(
        event.end,
        this.$store.state.user.timeZoneName,
        this.$moment
      );

      this.infoEventoDelete.startDate = event.start;
      this.infoEventoDelete.endDate = event.end;
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/GetScheduleByDelete?startDate=${startDate}&endDate=${endDate}&groupPlanId=${this.groupsPlan.id}`
        )

        .then((response) => {
          if (response.data != null) {
            if (response.data.value == 0) {
              this.$bvModal.show("modal-delete-class-without-result");
            } else {
              this.classDelete.id = response.data.value;
              this.idValueSelectEventSelectedTimeClassDelete(event);
              if (!response.data.return) {
                this.$bvModal.show("delete-recurring-class");
              } else {
                this.$bvModal.show("modal-delete-class");
              }
            }
          }
        });
    },
    handleEvents(events) {
      let newEvents = events.event;
      let oldEvent = events.oldEvent;

      let fechaInicio = newEvents.startStr;
      let fechaFin = newEvents.endStr;

      let eventCurrent = this.calendarOptions.events.find(function (e) {
        return (
          new Date(e.start).getTime() ==
            new Date(oldEvent.startStr).getTime() &&
          new Date(e.end).getTime() == new Date(oldEvent.endStr).getTime() &&
          e.request === true
        );
      });
      let noRecurrent = eventCurrent.noRecurrent;
      let dateSelectStart = new Date(fechaInicio);
      let dateSelectEnd = new Date(fechaFin);
      let dateEnd = null;

      let dateAfter = new Date(
        dateSelectStart.setMinutes(
          dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
        )
      );
      if (dateSelectEnd.getTime() < dateAfter.getTime()) {
        dateEnd = dateSelectEnd;
      } else {
        dateEnd = dateAfter;
      }

      if (noRecurrent) {
        this.listCalendar = this.listCalendar.filter(function (e) {
          return (
            new Date(e.StartDate).getTime() !==
              new Date(oldEvent.startStr).getTime() &&
            new Date(e.EndDate).getTime() !==
              new Date(oldEvent.endStr).getTime()
          );
        });

        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            return (
              new Date(e.start).getTime() !==
                new Date(oldEvent.startStr).getTime() &&
              new Date(e.end).getTime() !== new Date(oldEvent.endStr).getTime()
            );
          }
        );
      } else {
        const eventDayOfWeek = new Date(oldEvent.startStr).getDay();
        const eventTimeStart = oldEvent.startStr.slice(11, 16);
        const eventTimeEnd = oldEvent.endStr.slice(11, 16);
        const eventDate = new Date(oldEvent.startStr);
        this.arrayCalendarChange = this.arrayCalendarChange.filter((e) => {
          const eventStartDate = new Date(e.StartDate);
          return !(
            eventStartDate.getDay() === eventDayOfWeek &&
            e.StartDate.slice(11, 16) === eventTimeStart &&
            e.EndDate.slice(11, 16) === eventTimeEnd &&
            e.noRecurrent === false &&
            e.request === true &&
            eventStartDate >= eventDate
          );
        });

        this.listCalendar = this.listCalendar.filter((e) => {
          const eventStartDate = new Date(e.StartDate);
          return !(
            eventStartDate.getDay() === eventDayOfWeek &&
            e.StartDate.slice(11, 16) === eventTimeStart &&
            e.EndDate.slice(11, 16) === eventTimeEnd &&
            e.noRecurrent === false &&
            e.request === true &&
            eventStartDate >= eventDate
          );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => {
            const eventStartDate = new Date(e.start);
            return !(
              eventStartDate.getDay() === eventDayOfWeek &&
              e.start.slice(11, 16) === eventTimeStart &&
              e.end.slice(11, 16) === eventTimeEnd &&
              e.noRecurrent === false &&
              e.request === true &&
              eventStartDate >= eventDate
            );
          }
        );

        // eliminar el anterior
        this.listCalendar = this.listCalendar.filter(function (e) {
          return (
            new Date(e.StartDate).getTime() !==
              new Date(oldEvent.startStr).getTime() &&
            new Date(e.EndDate).getTime() !==
              new Date(oldEvent.endStr).getTime()
          );
        });

        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            return (
              new Date(e.start).getTime() !==
                new Date(oldEvent.startStr).getTime() &&
              new Date(e.end).getTime() !== new Date(oldEvent.endStr).getTime()
            );
          }
        );
      }
      events.event.remove();

      let _eventItemMerge = ValidarMergeHorariosByRecurrent(
        this.calendarOptions.events,
        fechaInicio,
        fechaFin,
        this.$moment,
        noRecurrent
      );
      let p_idEvent = createEventId();
      if (Object.keys(_eventItemMerge).length !== 0) {
        this.arrayCalendarChange.forEach((obj, i) => {
          if (obj.id == _eventItemMerge.idx) {
            obj.StartDate = this.$moment(_eventItemMerge.start).format(
              this.formatDateSchedule
            );
            obj.EndDate = this.$moment(_eventItemMerge.end).format(
              this.formatDateSchedule
            );
          }
        });

        this.listCalendar.forEach((obj, i) => {
          if (
            obj.idx ==
            (_eventItemMerge.idx == 0
              ? _eventItemMerge.id
              : parseInt(_eventItemMerge.idx, 10))
          ) {
            obj.StartDate = this.$moment(_eventItemMerge.start).format(
              this.formatDateSchedule
            );
            obj.EndDate = this.$moment(_eventItemMerge.end).format(
              this.formatDateSchedule
            );
          }
        });
      } else {
        let idx = this.obtenerCalendarId();

        let data2 = {
          id: idx,
          StartDate: this.$moment(fechaInicio).format(this.formatDateSchedule),
          EndDate: this.$moment(dateEnd).format(this.formatDateSchedule),
          StateClass: Constants.CALENDAR_STATUS.CONFIRM.VALUE,
          request: true,
          editable: true,
          noRecurrent: noRecurrent,
          isNew: true,
          flagPlantTest: false,
        };

        this.listCalendar.push(data2);

        this.calendarOptions.events.push({
          idx: idx,
          id: p_idEvent, //createEventId(),
          start: this.$moment(fechaInicio).format(this.formatDateSchedule),
          end: this.$moment(dateEnd).format(this.formatDateSchedule),
          title: this.$t("horario.calendario.label-calendar-teacher", {
            TeacherName: this.dataTeacher.firstName,
          }),
          editable: true,
          request: true,
          color: noRecurrent
            ? Constants.CALENDAR_STATUS_ADDITIONAL_COLOR.NORECURRENT
            : Constants.CALENDAR_STATUS.CONFIRM.COLOR,
          noRecurrent: noRecurrent,
          isNew: true,
          isInList: false,
        });
      }

      if (!noRecurrent) {
        let replicatedStartDate = new Date(fechaInicio);
        const expirationDate = new Date(this.groupsPlan.expirationDate);

        while (replicatedStartDate < expirationDate) {
          replicatedStartDate.setDate(replicatedStartDate.getDate() + 7);
          dateEnd.setDate(dateEnd.getDate() + 7);

          let _eventItemMerge = ValidarMergeHorariosByRecurrent(
            this.calendarOptions.events,
            replicatedStartDate.toISOString(),
            dateEnd.toISOString(),
            this.$moment,
            false
          );

          if (Object.keys(_eventItemMerge).length !== 0) {
            this.JoinEvent(_eventItemMerge);
          } else {
            let newIdx = this.obtenerCalendarId();
            this.AddNewEvent(
              newIdx,
              p_idEvent,
              replicatedStartDate,
              dateEnd,
              false
            );
          }
        }
      }
    },

    SaveClassRegister() {
      this.$v.classRegister.$touch();
      if (this.$v.classRegister.$invalid) {
        return;
      }

      this.idValueSelectEventSelectedTimeClassRegister(this.eventCreated);
      let fechaInicio = this.eventCreated.startStr;
      let fechaFin = this.eventCreated.endStr;

      this.editHourTotal += this.hoursEdit;

      let idx = this.obtenerCalendarId();
      let _id = createEventId();
      let dateSelectStart = new Date(fechaInicio);
      let dateSelectEnd = new Date(fechaFin);
      let dateEnd;

      let noRecurrent = this.classRegister.typeClass === "true";

      if (this.flagPlanTest) {
        dateEnd = new Date(dateSelectStart);
        dateEnd.setMinutes(
          dateEnd.getMinutes() + this.maximoHorasCalendario * 60
        );
      } else {
        let dateAfter = new Date(dateSelectStart);
        dateAfter.setMinutes(
          dateAfter.getMinutes() + this.maximoHorasCalendario * 60
        );
        dateEnd =
          dateSelectEnd.getTime() < dateAfter.getTime()
            ? dateSelectEnd
            : dateAfter;
      }

      let num = this.ObtenerRangoFecha(
        fechaInicio,
        dateEnd.toISOString(),
        this.listCalendar
      );

      if (num === 0) {
        let replicatedStartDate = new Date(fechaInicio);
        const expirationDate = new Date(this.groupsPlan.expirationDate);

        let _eventItemMerge = ValidarMergeHorariosByRecurrent(
          this.calendarOptions.events,
          replicatedStartDate.toISOString(),
          dateEnd.toISOString(),
          this.$moment,
          noRecurrent
        );

        if (Object.keys(_eventItemMerge).length !== 0) {
          this.JoinEvent(_eventItemMerge);
        } else {
          this.AddNewEvent(idx, _id, replicatedStartDate, dateEnd, noRecurrent);
        }

        if (noRecurrent) {
          this.flagChange = true;
          this.FinishSaved();
          return;
        }
        while (replicatedStartDate < expirationDate) {
          replicatedStartDate.setDate(replicatedStartDate.getDate() + 7);
          dateEnd.setDate(dateEnd.getDate() + 7);

          let _eventItemMerge = ValidarMergeHorariosByRecurrent(
            this.calendarOptions.events,
            replicatedStartDate.toISOString(),
            dateEnd.toISOString(),
            this.$moment,
            false
          );

          if (Object.keys(_eventItemMerge).length !== 0) {
            this.JoinEvent(_eventItemMerge);
          } else {
            let newIdx = this.obtenerCalendarId();
            this.AddNewEvent(newIdx, _id, replicatedStartDate, dateEnd, false);
          }
        }
        this.flagChange = true;
        this.FinishSaved();
      } else {
        this.message = `${this.$t(
          "modals.modalViewSchedule.maximoHorasCalendario.1"
        )} ${this.maximoHorasCalendario * 60} ${this.$t(
          "modals.modalViewSchedule.maximoHorasCalendario.2"
        )}`;
        this.$bvToast.show("toast-equis-modal-calendar-class");
      }
    },

    JoinEvent(eventItemMerge) {
      this.arrayCalendarChange.forEach((obj) => {
        if (obj.id === eventItemMerge.idx) {
          obj.StartDate = this.$moment(eventItemMerge.start).format(
            this.formatDateSchedule
          );
          obj.EndDate = this.$moment(eventItemMerge.end).format(
            this.formatDateSchedule
          );
        }
      });

      this.listCalendar.forEach((obj) => {
        if (
          obj.idx ===
          (eventItemMerge.idx === 0
            ? eventItemMerge.id
            : parseInt(eventItemMerge.idx, 10))
        ) {
          obj.StartDate = this.$moment(eventItemMerge.start).format(
            this.formatDateSchedule
          );
          obj.EndDate = this.$moment(eventItemMerge.end).format(
            this.formatDateSchedule
          );
        }
      });
    },

    AddNewEvent(idx, _id, start, end, noRecurrent) {
      let eventData = {
        id: idx,
        StartDate: this.$moment(start).format(this.formatDateSchedule),
        EndDate: this.$moment(end).format(this.formatDateSchedule),
        StateClass: Constants.CALENDAR_STATUS.CONFIRM.VALUE,
        request: true,
        editable: true,
        noRecurrent: noRecurrent,
        isNew: true,
      };

      this.arrayCalendarChange.push(eventData);
      this.listCalendar.push(eventData);

      this.calendarOptions.events.push({
        idx: idx,
        id: _id,
        description: "",
        start: this.$moment(start).format(this.formatDateSchedule),
        end: this.$moment(end).format(this.formatDateSchedule),
        title: this.$t("horario.calendario.label-calendar-teacher", {
          TeacherName: this.dataTeacher.firstName,
        }),
        editable: true,
        request: true,
        color: noRecurrent
          ? Constants.CALENDAR_STATUS_ADDITIONAL_COLOR.NORECURRENT
          : Constants.CALENDAR_STATUS.CONFIRM.COLOR,
        noRecurrent: noRecurrent,
        isNew: true,
        isInList: false,
      });
    },

    FinishSaved() {
      this.disabledDate = false;
      this.getDateMinMax(new Date());
      this.$bvModal.hide("modal-add-class");

      if (this.classRegister.typeClass === "true") {
        this.classRegister.idx = createEventId();
        this.listClassRegister.push(this.classRegister);
      }

      this.classRegister = {
        id: "",
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        noRecurrent: false,
        isNew: false,
      };

      this.$bvModal.hide("modal-add-class");
      this.$v.classRegister.$reset();
    },
    idValueSelectEventSelectedTime(event) {
      this.selectedTime = event;
    },
    idValueSelectEventSelectedTimeClassRegister(event) {
      if (event != null) {
        this.classRegister.id = 0;
        this.classRegister.startDate = event.startStr;
        this.classRegister.endDate = event.endStr;
        this.classRegister.noRecurrent = true;
        this.classRegister.stateClassId = parseInt(
          Constants.CALENDAR_STATUS.CONFIRM.VALUE
        );
        this.classRegister.isNew = true;
      }
    },
    idValueSelectEventSelectedTimeClassDelete(event) {
      if (event != null) {
        this.classDelete.startDate = event.start;
        this.classDelete.endDate = event.end;
        this.classDelete.isDelete = true;
        this.classDelete.stateClassId = parseInt(
          Constants.CALENDAR_STATUS.CONFIRM.VALUE
        );
      }
    },

    getWeek() {
      let calendarApi = this.$refs.fullCalendarStudent.getApi();
      calendarApi.gotoDate(this.uniqDate[this.selectedTime]);
    },
    handleSelecAllow(selectInfo) {
      let num = this.ObtenerRangoFecha(selectInfo.startStr, selectInfo.endStr);

      if (num > 0) {
        return false;
      }

      let valueBefore = true;
      let valueAfter = this.$moment(new Date(selectInfo.start)).isAfter(
        new Date()
      );

      if (this.flagPlanTest) {
        let endAfterDate = selectInfo.end;
        let dateSelectStart = new Date(selectInfo.start);
        let arraySend = this.listCalendar.filter((currentValue) => {
          return currentValue.request;
        });

        if (arraySend.length == 1) {
          return false;
        }
        let dataStar = this.$moment(selectInfo.start);
        let dateCurrent = new Date();
        let newDateCurrent = new Date(
          dateCurrent.setMinutes(
            dateCurrent.getMinutes() - 2 * (this.maximoHorasCalendario * 60)
          )
        );
        let dataAfter = this.$moment(newDateCurrent).add(
          this.daysMaxSchedule - 1,
          "days"
        );
        valueBefore = this.$moment(dataStar).isBefore(dataAfter);

        let dateAfter = new Date(
          dateSelectStart.setMinutes(
            dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
          )
        );

        if (
          new Date(endAfterDate).getTime() <= dateAfter.getTime() &&
          valueBefore &&
          valueAfter
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        //let dataStar = this.$moment(selectInfo.start).format("YYYY-MM-DD")
        let dateSelectStart = new Date(selectInfo.start);
        let endAfter = selectInfo.end;

        let dateAfter = new Date(
          dateSelectStart.setMinutes(
            dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
          )
        );

        if (endAfter.getTime() <= dateAfter.getTime()) {
          return true;
        } else {
          return false;
        }
      }
    },
    closeModal() {
      this.showAlertModal = false;
      this.message = "";
      this.$bvModal.hide("modal-add-event");
    },
    obtenerCalendarId() {
      let idx = 0;
      let dataTmp = this.listCalendar;

      let ultId =
        dataTmp.length == 0 ? 1 * -1000 : dataTmp[dataTmp.length - 1].id;
      ultId = ultId == null ? 0 : ultId;
      idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;

      return idx;
    },
    saveEvent() {
      let fechaInicio = this.eventCreated.startStr;
      let fechaFin = this.eventCreated.endStr;

      this.editHourTotal += this.hoursEdit;

      let idx = this.obtenerCalendarId();

      //let currentStart = new Date(fechaInicio)
      let dateSelectStart = new Date(fechaInicio);
      let dateSelectEnd = new Date(fechaFin);
      let dateEnd = null;

      if (this.flagPlanTest) {
        let dateAfter = new Date(
          dateSelectStart.setMinutes(
            dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
          )
        );
        dateEnd = dateAfter;
      } else {
        let dateAfter = new Date(
          dateSelectStart.setMinutes(
            dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
          )
        );
        if (dateSelectEnd.getTime() < dateAfter.getTime()) {
          dateEnd = fechaFin;
        } else {
          dateEnd = dateAfter;
        }
      }

      let num = this.ObtenerRangoFecha(fechaInicio, dateEnd, this.listCalendar);
      if (num == 0) {
        let eventData;
        //let eventMerge = false;
        let _eventItemMerge = ValidarMergeHorarios(
          this.calendarOptions.events,
          fechaInicio,
          dateEnd,
          this.$moment
        );

        if (Object.keys(_eventItemMerge).length != 0) {
          //si hay merge

          this.arrayCalendarChange.forEach((obj, i) => {
            if (obj.id == _eventItemMerge.idx) {
              obj.StartDate = this.$moment(_eventItemMerge.start).format(
                this.formatDateSchedule
              );
              obj.EndDate = this.$moment(_eventItemMerge.end).format(
                this.formatDateSchedule
              );
            }
          });
          this.listCalendar.forEach((obj, i) => {
            if (
              obj.idx ==
              (_eventItemMerge.idx == 0
                ? _eventItemMerge.id
                : parseInt(_eventItemMerge.idx, 10))
            ) {
              obj.StartDate = this.$moment(_eventItemMerge.start).format(
                this.formatDateSchedule
              );
              obj.EndDate = this.$moment(_eventItemMerge.end).format(
                this.formatDateSchedule
              );
            }
          });
          /*this.calendarOptions.events.forEach((obj, i) => {
                if(obj.idx == _eventItemMerge.idx) {
                  debugger;
                  obj.start = this.$moment(_eventItemMerge.start).format('YYYY-MM-DDTHH:mm:ss');
                  obj.end = this.$moment(_eventItemMerge.end).format('YYYY-MM-DDTHH:mm:ss');
                  return;
                }
              })
              */
        } else {
          eventData = {
            id: idx,
            StartDate: this.$moment(fechaInicio).format(
              this.formatDateSchedule
            ),
            EndDate: this.$moment(dateEnd).format(this.formatDateSchedule),
            StateClass: Constants.CALENDAR_STATUS.CONFIRM.VALUE,
            request: true,
            editable: true,
          };
          this.arrayCalendarChange.push(eventData);
          this.listCalendar.push(eventData);

          this.calendarOptions.events.push({
            idx: idx,
            id: createEventId(),
            description: "",
            start: this.$moment(fechaInicio).format(this.formatDateSchedule),
            end: this.$moment(dateEnd).format(this.formatDateSchedule),
            title: this.$t("horario.calendario.label-calendar-teacher", {
              TeacherName: this.dataTeacher.firstName,
            }),
            request: true,
            editable: true,
            isInList: false,
          });
        }

        this.disabledDate = false;

        this.getDateMinMax(new Date());
        this.$bvModal.hide("modal-add-event");
      } else {
        this.message = `${this.$t(
          "modals.modalViewSchedule.maximoHorasCalendario.1"
        )} ${this.maximoHorasCalendario * 60} ${this.$t(
          "modals.modalViewSchedule.maximoHorasCalendario.2"
        )} `;
        this.$bvToast.show("toast-equis-modal-calendar-class");
      }

      this.$bvModal.hide("modal-add-event");
    },
    cancelClass() {
      this.showSpinnerCancel = true;

      let data = {
        GroupScheduleStudentsDetailsId: this.infoClass.id,
        FlagTipo: true,
        FlagTipoCancelacion: this.flaganticipation,
        TeacherId: this.infoClass.personTeacherId,
        User: this.$store.state.user.email,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleStudents/GetScheduleCancelByTeacherStudent`,
          {
            params: data,
          }
        )
        .then((response) => {
          this.showSpinnerCancel = false;
          this.$bvModal.hide("modal-class-info");
          this.$bvModal.hide("modal-schedule-cancel-student");
          let format_time_validate = this.formatDateSchedule;
          switch (response.data.value) {
            case 0:
              this.message = this.$t("reusables.empty-text");
              this.$bvToast.show("toast-equis-modal-calendar-class");
              break;
            case 1:
              if (response.data.list != null && response.data.list.length > 0) {
                this.dateStartValidateNext =
                  response.data.list[0] != null
                    ? convertTimeToUserTimeFormat(
                        response.data.list[0].startDate,
                        this.$store.state.user.timeZoneName,
                        this.$moment,
                        format_time_validate
                      )
                    : "";
                this.dateEndValidateNext =
                  response.data.list[0] != null
                    ? convertTimeToUserTimeFormat(
                        response.data.list[0].endDate,
                        this.$store.state.user.timeZoneName,
                        this.$moment,
                        format_time_validate
                      )
                    : "";
                //PARSEAR FECHA DE PROXIMA CLASE AL HORARIO DEL ALUMNO
                let format_day = "DD/MM/YYYY";
                let format_time = "h:mm a";

                this.nextDateClass = getNextClassDate(
                  response.data.list[0].startDate,
                  this.$store.state.user.timeZoneName,
                  this.$moment,
                  format_day
                );
                this.nextClass = getNextClassTime(
                  response.data.list[0].startDate,
                  response.data.list[0].endDate,
                  this.$store.state.user.timeZoneName,
                  this.$moment,
                  format_time
                );

                this.nextClassLink =
                  response.data.entity.groupScheduleStudentsDetails != null
                    ? response.data.list[0].linkClass
                    : null;
              } else {
                this.nextDateClass = "";
                this.nextClass = "";
              }
              this.message = this.$t("reusables.records-have-been-updated");
              this.$bvToast.show("toast-check-modal-calendar-class");
              this.reply();
              break;
            case -1:
              this.message = this.$t("reusables.class-was-not-found");
              this.$bvToast.show("toast-equis-modal-calendar-class");
              break;
            case -2:
              this.message = this.$t("reusables.exceed-cancellation-number");
              this.$bvToast.show("toast-equis-modal-calendar-class");
              break;
            case -3:
              this.message = this.$t("reusables.cannot-cancel-class-finished");
              this.$bvToast.show("toast-equis-modal-calendar-class");
              break;
          }
        })
        .catch((err) => {
          this.showSpinnerCancel = false;
          this.message = this.$t("reusables.error-canceling-class");

          this.$bvToast.show("toast-equis-modal-calendar-class");
        });
    },

    editCalendar() {
      this.hideButtonsForEdit = true;
      let data = {
        PersonTeacherId: this.personTeacherId,
        GroupId: this.dataGroup,
        timeZoneName: this.$store.state.user.timeZoneName,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/GetScheduleStudentByEdited`,
          {
            params: data,
          }
        )
        .then((response) => {
          if (response.data.entity != null) {
            this.$bvModal.show("modal-not-edit");
          } else {
            if (this.groupsPlan != null && this.groupsPlan.flagPlanTest) {
              this.flagShowHeader = true;
              this.flagPlanTestEdit = true;
            }
            this.flagChange = false;
            this.listCalendar = [];
            this.arrayCalendarInit = [];
            this.listClassRegister = [];
            this.listClassDelete = [];
            this.classDeleteTimeClass = " ";
            this.calendarOptions.events = [];
            (this.disabledDate = true), (this.flagEdit = true);
            this.calendarOptions.selectable = true;
            let arrayList = response.data.list;

            this.showSelectWeek = true;
            this.calendarOptions.headerToolbar = getCalendarHeaderToolbar(
              this.flagShowHeader
            );
            this.hideButtonsForEdit = false;
            let arrayInitWeek = [];
            let arrayEnabledDate = [];
            let scheduleTotal = [];
            arrayList.forEach((element) => {
              let startOfWeek = this.$moment(element.startDate)
                .startOf("week")
                .toDate();
              let endOfWeek = this.$moment(element.startDate)
                .endOf("week")
                .toDate();

              let month =
                parseInt(startOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(startOfWeek.getMonth()) + 1}`
                  : parseInt(startOfWeek.getMonth()) + 1;
              let dayDate =
                parseInt(startOfWeek.getDate()) < 10
                  ? `0${parseInt(startOfWeek.getDate())}`
                  : parseInt(parseInt(startOfWeek.getDate()));

              let monthEnd =
                parseInt(endOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getMonth()) + 1}`
                  : parseInt(endOfWeek.getMonth()) + 1;
              let dayDateEnd =
                parseInt(endOfWeek.getDate()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getDate()) + 1}`
                  : parseInt(parseInt(endOfWeek.getDate()) + 1);

              arrayInitWeek.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );

              arrayEnabledDate.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );
              arrayEnabledDate.push(
                endOfWeek.getFullYear() + "-" + monthEnd + "-" + dayDateEnd
              );

              let jsonData = {
                id: createEventId(),
                title: element.flagUpdate
                  ? this.$t("horario.calendario.label-calendar-teacher", {
                      TeacherName: this.dataTeacher.firstName,
                    })
                  : this.$t("reusables.unavailable"),
                description: "",
                idx: element.id,
                start: element.startDate,
                end:
                  this.$moment(element.endDate).format("mm") == "59"
                    ? this.$moment(element.endDate)
                        .add(1, "minutes")
                        .format("YYYY-MM-DDTHH:mm:ss")
                    : element.endDate,
                color: element.flagUpdate
                  ? element.noRecurrent
                    ? Constants.CALENDAR_STATUS_ADDITIONAL_COLOR.NORECURRENT
                    : Constants.CALENDAR_STATUS.CONFIRM.COLOR
                  : Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR,
                editable: element.flagUpdate,
                request: element.flagUpdate,
                isNew: false,
                noRecurrent: element.noRecurrent,
                isInList: false,
              };

              let data = {
                id: element.id,
                idx: jsonData.id,
                StartDate: element.startDate,
                EndDate:
                  this.$moment(element.endDate).format("mm") == "59"
                    ? this.$moment(element.endDate)
                        .add(1, "minutes")
                        .format("YYYY-MM-DDTHH:mm:ss")
                    : element.endDate,
                editable: element.flagUpdate,
                request: element.flagUpdate,
                isNew: false,
                noRecurrent: element.noRecurrent,
              };

              let dataInit = {
                id: element.id,
                idx: jsonData.id,
                StartDate: element.startDate,
                EndDate:
                  this.$moment(element.endDate).format("mm") == "59"
                    ? this.$moment(element.endDate)
                        .add(1, "minutes")
                        .format("YYYY-MM-DDTHH:mm:ss")
                    : element.endDate,
                editable: element.flagUpdate,
                request: element.flagUpdate,
                isNew: false,
                noRecurrent: element.noRecurrent,
              };

              this.listCalendar.push(data);
              this.arrayCalendarInit.push(dataInit);
              this.calendarOptions.events.push(jsonData);
              scheduleTotal.push(data);
            });
            this.optionsTime = [];
            this.uniqDateEnabled = [...new Set(arrayEnabledDate)];
            let endDateParam = this.$moment(
              this.groupsPlan.expirationDate
            ).format("YYYY-MM-DD");
            let endDate = this.$moment(this.groupsPlan.expirationDate)
              .add(1, "day")
              .endOf("day")
              .format("YYYY-MM-DD");

            if (this.uniqDateEnabled.length > 1) {
              let startDate = this.$moment(new Date()).format("YYYY-MM-DD");
              //this.uniqDateEnabled[this.uniqDateEnabled.length - 1];

              if (
                !this.$moment(endDate, "YYYY-MM-DD", true).isValid() ||
                this.$moment(endDate).isBefore(startDate)
              ) {
                endDate = startDate;
              }
              this.calendarOptions.validRange = {
                start: startDate,
                end: endDate,
              };
            }

            let orderScheduleTotal = [
              ...new Set(
                scheduleTotal.map((item) =>
                  this.$moment(item.StartDate)
                    .startOf("week")
                    .format("YYYY-MM-DD")
                )
              ),
            ];
            let startOfWeekCurrent = this.$moment(
              orderScheduleTotal[0]
            ).startOf("week");
            let endOfWeekFinal = this.$moment(endDateParam).endOf("week");

            this.uniqDate = [];
            let countSelect = 0;
            let countValited = 0;
            let weekIndex = 0;
            while (startOfWeekCurrent.isSameOrBefore(endOfWeekFinal)) {
              let startOfWeekFormatted =
                startOfWeekCurrent.format("YYYY-MM-DD");
              this.uniqDate.push(startOfWeekFormatted);
              let isBeforeCurrentWeek = startOfWeekCurrent.isBefore(
                this.$moment().startOf("week"),
                "day"
              );
              if (
                startOfWeekCurrent.isSame(this.$moment().startOf("week"), "day")
              ) {
                countSelect = weekIndex;
                countValited++;
              }

              this.optionsTime.push({
                value: weekIndex,
                text: this.$t("reusables.week") + ` ${weekIndex + 1}`,
                disabled: isBeforeCurrentWeek,
              });

              startOfWeekCurrent.add(1, "week");
              weekIndex++;
            }

            if (this.uniqDate.length > 0) {
              this.selectedTime = countSelect;
              this.selectTimeInit = countSelect;
            }

            if (countValited == 0) {
              this.selectedTime = this.uniqDate.length - 1;
              this.selectTimeInit = this.uniqDate.length - 1;
            }
            this.formatDay = "DD";
            setTimeout(() => {
              if (this.listCalendar.length > 0) {
                let calendarApi = this.$refs.fullCalendarStudent.getApi();
                calendarApi.gotoDate(new Date());
              }
            }, 500);
          }
        });
    },
    reply() {
      if (this.groupsPlan != null && this.groupsPlan.flagPlanTest) {
        this.flagShowHeader = false;
        this.flagPlanTestEdit = false;
      }
      (this.disabledDate = true), (this.showSelectWeek = true);
      this.calendarOptions.headerToolbar = getCalendarHeaderToolbar(
        this.flagShowHeader
      );
      this.formatDay = "DD";
      this.flagEdit = false;
      this.calendarOptions.selectable = false;
      this.showLoadingCalendar = true;
      this.getListScheduleClass();
    },
    async getDataClass(data) {
      this.dateStartValidate = null;
      this.dateEndValidate = null;
      this.messageResult = "";
      await baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleStudents/GetScheduleStudentByiD?scheduleId=` +
            data["_def"].extendedProps.idx
        )
        .then((response) => {
          this.listCalendar.filter(function (e) {
            if (e.id == data["_def"].extendedProps.idx) {
              e.StateClass = response.data.entity.stateClass.value;
            }
          });
          let colorResquest = horarioObtenerColorClaseConsolidado(
            response.data.entity.stateClass.strValue
          );
          this.calendarOptions.events.filter(function (e) {
            if (e.idx == data["_def"].extendedProps.idx) {
              e.color = colorResquest;
              e.stateClass = response.data.entity.stateClass.value;
              e.stateClassName = response.data.entity.stateClass.name;
            }
          });
          let format_time_validate = this.formatDateSchedule;

          this.dateStartValidate = convertTimeToUserTimeFormat(
            response.data.entity.startDate,
            this.$store.state.user.timeZoneName,
            this.$moment,
            format_time_validate
          );
          this.dateEndValidate = convertTimeToUserTimeFormat(
            response.data.entity.endDate,
            this.$store.state.user.timeZoneName,
            this.$moment,
            format_time_validate
          );

          if (!this.flagEdit) {
            let json = {
              subjectsName: data["_def"].extendedProps.subjectsName,
              startDate: data.startStr,
              endDate: data.endStr,
              id: data["_def"].extendedProps.idx,
              personTeacherId: data["_def"].extendedProps.personTeacherId,
              personTeacherName:
                data["_def"].extendedProps.personTeacherNameFull,
              /*color :data.backgroundColor,
              stateClass: data["_def"].extendedProps.stateClass,
              stateClassName : data["_def"].extendedProps.stateClassName,*/

              color: colorResquest,
              stateClass: response.data.entity.stateClass.value,
              stateClassName: horarioObtenerNameClaseEnEsConsolidado(
                response.data.entity.stateClass.strValue
              ),
              linkClass: data["_def"].extendedProps.linkClass,
              flagGroup: data["_def"].extendedProps.flagGroup,
            };

            let newDate = new Date(data.startStr);

            newDate.setHours(
              newDate.getHours() - this.nroHoursAnticipationLessonCancel
            );

            let currentDate = new Date();

            if (currentDate.getTime() > newDate.getTime()) {
              this.flaganticipation = true;
            } else {
              this.flaganticipation = false;
            }

            this.infoClass = json;

            this.$bvModal.show("modal-class-info");
          }
        });
    },
    async getCourses() {
      await baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupRegisterSubjects/GetByGroupId?GroupsId=` +
            this.dataGroup
        )
        .then((response) => {
          if (response.data) {
            if (response.data.entity) {
              this.titleCourse = response.data.entity.subjectsName.replace(
                ",",
                "\n"
              );
            }
          }
        });
    },

    getListScheduleClass() {
      this.listCalendar = [];
      this.arrayCalendarInit = [];
      let data = {
        GroupId: this.dataGroup,
        IdPersonStudent: this.$store.state.user.personStudentId,
        flagLanguage: this.lang == "es" ? true : false,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleStudents/GetScheduleStudentByGroup`,
          {
            params: data,
          }
        )
        .then((response) => {
          if (response.data.entity) {
            let format_time_validate = this.formatDateSchedule;

            this.groupScheduleStrundetId = response.data.entity.id;
            this.showEditSchedule = response.data.entity.flagProposalEdited;
            this.isResponseReceived = response.data.entity.isResponseReceived;
            this.groupsScheduleProposalEditedId =
              response.data.entity.groupsScheduleProposalEditedId;
            this.proposalId = response.data.entity.groupScheduleProposalId;
            this.personTeacherId =
              response.data.entity.personsTeachers != null
                ? response.data.entity.personsTeachers.id
                : null;
            this.SelectBeginningDateInit = response.data.entity.beginningDate;
            this.SelectBeginningDate = "";
            this.flagPlanTest = response.data.entity.flagPlanTest;
            this.nroHoursAnticipationLessonCancel =
              response.data.entity.nroHoursAnticipationLessonCancel;
            this.dateStartValidateNext =
              response.data.entity.groupScheduleStudentsDetails != null
                ? convertTimeToUserTimeFormat(
                    response.data.entity.groupScheduleStudentsDetails.startDate,
                    this.$store.state.user.timeZoneName,
                    this.$moment,
                    format_time_validate
                  )
                : "";
            this.dateEndValidateNext =
              response.data.entity.groupScheduleStudentsDetails != null
                ? convertTimeToUserTimeFormat(
                    response.data.entity.groupScheduleStudentsDetails.endDate,
                    this.$store.state.user.timeZoneName,
                    this.$moment,
                    format_time_validate
                  )
                : "";
            this.hideButtonsForEdit = false;
            //PARSEAR FECHA DE PROXIMA CLASE AL HORARIO DEL ALUMNO
            if (response.data.entity.groupScheduleStudentsDetails != null) {
              let format_day = "DD/MM/YYYY";
              let format_time = "h:mm a";

              this.nextDateClass = getNextClassDate(
                response.data.entity.groupScheduleStudentsDetails.startDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_day
              );
              this.nextClass = getNextClassTime(
                response.data.entity.groupScheduleStudentsDetails.startDate,
                response.data.entity.groupScheduleStudentsDetails.endDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_time
              );
            } else {
              this.nextDateClass = "";
              this.nextClass = "";
            }
            this.nextClassLink =
              response.data.entity.groupScheduleStudentsDetails != null
                ? response.data.entity.groupScheduleStudentsDetails.linkClass
                : null;

            let json = {
              totalCommentary:
                response.data.entity.personsTeachers != null
                  ? response.data.entity.personsTeachers.totalCommentary
                  : null,
              totalQualification:
                response.data.entity.personsTeachers != null
                  ? response.data.entity.personsTeachers.totalQualification
                  : null,
              strFullName:
                response.data.entity.personsTeachers != null
                  ? response.data.entity.flagGroup
                    ? response.data.entity.code
                    : response.data.entity.personsTeachers.person.strFullName
                  : null,
              photo:
                response.data.entity.personsTeachers != null
                  ? response.data.entity.personsTeachers.person.photo
                  : null,
              location:
                response.data.entity.personsTeachers != null
                  ? response.data.entity.personsTeachers.person
                      .countryOriginDescription
                  : null, //se reemplazo
              id:
                response.data.entity.personsTeachers != null
                  ? response.data.entity.personsTeachers.id
                  : null,
              personId:
                response.data.entity.personsTeachers != null
                  ? response.data.entity.personsTeachers.personId
                  : null,
              firstName:
                response.data.entity.personsTeachers != null
                  ? response.data.entity.flagGroup
                    ? response.data.entity.code
                    : response.data.entity.personsTeachers.person.firstName
                  : null,
              lastName:
                response.data.entity.personsTeachers != null
                  ? response.data.entity.flagGroup
                    ? response.data.entity.code
                    : response.data.entity.personsTeachers.person.lastName
                  : null,
            };

            this.dataTeacher = json;

            let arrayHoursTmp =
              response.data.entity.listGroupScheduleStudentsDetails;
            let arrayHours = convertToUserTimeCalendarEvents(
              arrayHoursTmp,
              this.$store.state.user.timeZoneName,
              this.$moment
            );
            //let arrayHours = response.data.entity.listGroupScheduleStudentsDetails;

            let dataList = [];
            let arrayInitWeek = [];
            let arrayEnabledDate = [];

            arrayHours.forEach((element) => {
              let startOfWeek = this.$moment(element.startDate)
                .startOf("week")
                .toDate();
              let endOfWeek = this.$moment(element.startDate)
                .endOf("week")
                .toDate();

              let month =
                parseInt(startOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(startOfWeek.getMonth()) + 1}`
                  : parseInt(startOfWeek.getMonth()) + 1;
              let dayDate =
                parseInt(startOfWeek.getDate()) < 10
                  ? `0${parseInt(startOfWeek.getDate())}`
                  : parseInt(parseInt(startOfWeek.getDate()));

              let monthEnd =
                parseInt(endOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getMonth()) + 1}`
                  : parseInt(endOfWeek.getMonth()) + 1;
              let dayDateEnd =
                parseInt(endOfWeek.getDate()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getDate()) + 1}`
                  : parseInt(parseInt(endOfWeek.getDate()) + 1);

              arrayInitWeek.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );

              arrayEnabledDate.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );
              arrayEnabledDate.push(
                endOfWeek.getFullYear() + "-" + monthEnd + "-" + dayDateEnd
              );

              let colorResquest = horarioObtenerColorClaseConsolidado(
                element.stateClass.strValue
              );
              let titleClass = this.$t(
                "horario.calendario.label-calendar-teacher",
                { TeacherName: element.personTeacher.person.firstName }
              );

              if (this.flagPlanTest) {
                titleClass =
                  titleClass + "\n" + this.$t("reusables.test-class");
              }

              let nameClass = horarioObtenerNameClaseEnEsConsolidado(
                element.stateClass.strValue
              );

              this.arrayEditableSchedule.push(element.id);
              let jsonData = {
                id: createEventId(),
                subjectsName:
                  this.lang == "es"
                    ? element.subjectsName.replace("|", "\n")
                    : element.subjectsName_EN.replace("|", "\n"),
                title: titleClass,
                description: "",
                idx: element.id,
                personTeacherId: element.personTeacherId,
                start: element.startDate,
                personTeacherName: element.flagGroup
                  ? element.code
                  : element.personTeacher.person.lastName,
                personTeacherNameFull: element.flagGroup
                  ? element.code
                  : element.personTeacher.person.strFullName,
                end: element.endDate,
                color: colorResquest,
                stateClass: element.stateClass.value,
                stateClassName: nameClass,
                flagPlanTest: element.flagPlanTest,
                flagGroup: element.flagGroup,
                editable: false,
                linkClass: element.linkClass,
                isInList: false,
              };

              let data = {
                id: element.id,
                StartDate: element.startDate,
                EndDate: element.endDate,
                StateClass: element.stateClass.value,
                request: true,
              };
              dataList.push(jsonData);
              this.listCalendar.push(data);
              this.arrayCalendarInit.push(data);
            });

            this.optionsTime = [];
            this.uniqDateEnabled = [...new Set(arrayEnabledDate)];

            if (this.uniqDateEnabled.length > 1) {
              this.calendarOptions.validRange = {
                start: this.uniqDateEnabled[0],
                end: this.uniqDateEnabled[this.uniqDateEnabled.length - 1],
              };
            }

            let startOfWeekCurrent = this.$moment().startOf("week").toDate();
            this.uniqDate = [...new Set(arrayInitWeek)];
            let countSelect = 0;
            let countValited = 0;
            for (let index = 0; index < this.uniqDate.length; index++) {
              if (
                this.$moment(startOfWeekCurrent).format("YYYY-MM-DD") ==
                this.uniqDate[index]
              ) {
                countSelect = index;
                countValited++;
              }
              this.optionsTime.push({
                value: index,
                text: this.$t("reusables.week") + ` ${index + 1}`,
              });
            }
            if (this.uniqDate.length > 0) {
              this.selectedTime = countSelect;
              this.selectTimeInit = countSelect;
            }
            if (countValited == 0) {
              this.selectedTime = this.uniqDate.length - 1;
              this.selectTimeInit = this.uniqDate.length - 1;
            }
            this.calendarOptions.events = dataList;
          }
          this.showLoadingFirst = false;
          this.showLoadingCalendar = false;

          setTimeout(() => {
            if (this.uniqDate.length > 0) {
              let calendarApi = this.$refs.fullCalendarStudent.getApi();
              calendarApi.gotoDate(new Date());
            }
          }, 500);
        });
    },
    handleDateSelect(selectInfo) {
      this.messageAddClass = "";
      let now = new Date();
      let expirationDate = new Date(this.groupsPlan.expirationDate);
      let startRange = new Date(this.calendarOptions.validRange.start);
      let endRange = new Date(this.calendarOptions.validRange.end);

      if (selectInfo.start < now) {
        this.messageAddClass = this.$t("reusables.student-edited-schedule-12");
        this.$bvModal.show("modal-validate-register-class");
        return;
      } else if (selectInfo.start < startRange || selectInfo.end > endRange) {
        this.messageAddClass = this.messageAddClass = this.$t(
          "reusables.student-edited-schedule-13"
        );
        this.$bvModal.show("modal-validate-register-class");
        return;
      } else if (selectInfo.start > expirationDate) {
        this.messageAddClass = this.messageAddClass = this.$t(
          "reusables.student-edited-schedule-13"
        );
        this.$bvModal.show("modal-validate-register-class");
        return;
      } else {
        this.eventCreated = selectInfo;
        if (this.groupsPlan != null && this.groupsPlan.flagPlanTest) {
          this.$bvModal.show("modal-add-event");
        } else {
          this.$bvModal.show("modal-add-class");
        }
      }
    },
    closeModalRemove() {
      this.showAlertModal = false;
      this.message = "";
      this.$bvModal.hide("modal-class-info");
    },

    getTeacherInformationAndComments(id) {
      let flag = this.lang == "es" ? true : false;
      baseInstanceAxios
        .get(
          this.apiURL +
            `/resources/PersonsTeachers/GeTeacherInformationAndCommentList?PersonTeacherId=${id}&flagLanguage=${flag}`
        )
        .then((response) => {
          if (response.data != null && response.data.entity != null) {
            this.teacherInformation = response.data.entity;
            this.$bvModal.show("modal-commentary-teacher");
          }
        });
    },
    ObtenerRangoFecha(StartDate, EndDate) {
      var result = this.listCalendar.filter(function (e) {
        return (
          (!(
            new Date(StartDate).getTime() == new Date(e.StartDate).getTime()
          ) &&
            new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.EndDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime())
        );
      });
      return result.length;
    },
    validationForm: validationMessage(formUpdateDateMessages),
    showModalEditarHorario() {
      this.listResult = [];
      this.calendarOptions.events.forEach((event) => {
        event.isInList = false;
      });
      if (
        this.flagChange == false &&
        this.listClassDelete.filter(
          (item) =>
            item.id > 0 && (item.isNew === undefined || item.isNew === false)
        ).length > 0
      ) {
        this.flagCancelClass = true;
        this.saveChangeDelete();
      } else {
        this.SelectBeginningDate = "";
        this.$v.$reset();
        this.listRecurrent = [];
        this.listRecurrent = this.groupedEvents();
        this.$bvModal.show("modal-save-change");
      }
    },
    groupedEvents() {
      let grouped = {};
      let pListRecurrent = this.calendarOptions.events.filter(
        (currentValue) => {
          return currentValue.editable && !(currentValue.noRecurrent == true);
        }
      );
      pListRecurrent.forEach((event) => {
        const formattedDate = this.getFormatDateCompleteTitle(
          event.start,
          event.end
        );
        if (!grouped[formattedDate]) {
          grouped[formattedDate] = [];
        }
        grouped[formattedDate].push(event);
      });
      const dayOrder =
        localStorage.getItem("lang") == "es"
          ? this.ARRAY_DIA_SEMANA.ES
          : this.ARRAY_DIA_SEMANA.EN;

      const dayOrderIndex = dayOrder.reduce((acc, day, index) => {
        acc[day] = index;
        return acc;
      }, {});

      return Object.keys(grouped)
        .map((date) => {
          const dayName = date.split(",")[0];
          const timeRange = date.split(",")[1].trim();
          return {
            date: date,
            events: grouped[date],
            dayOrder: dayOrderIndex[dayName],
            timeRange: timeRange,
          };
        })
        .sort((a, b) => {
          if (a.dayOrder !== b.dayOrder) {
            return a.dayOrder - b.dayOrder;
          }
          return a.timeRange.localeCompare(
            b.timeRange,
            localStorage.getItem("lang") === "es" ? "es" : "en"
          );
        })
        .map((group) => {
          return {
            date: group.date,
            events: group.events,
          };
        });
    },
    validateChanges() {
      let elmts = [];
      let arrayCalendar = [];
      let arrayCalendarInit = [];
      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });
      let arraySendInit = this.arrayCalendarInit.filter((currentValue) => {
        return currentValue.request;
      });
      arraySend.forEach((element) => {
        arrayCalendar.push(
          `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
        );
      });
      arraySendInit.forEach((element) => {
        arrayCalendarInit.push(
          `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
        );
      });
      if (arrayCalendar.length > arrayCalendarInit.length) {
        elmts = arrayCalendar.filter(function (i) {
          return this.indexOf(i) < 0;
        }, arrayCalendarInit);
      } else {
        elmts = arrayCalendarInit.filter(function (i) {
          return this.indexOf(i) < 0;
        }, arrayCalendar);
      }
      if (arraySend.length == 0) {
        return true;
      } else {
        return elmts.length == 0 ? true : false;
      }
    },
  },
  computed: {
    expiryDaysLeft() {
      if (!this.groupsPlan || !this.groupsPlan.expirationDate) return null;
      const exp = this.$moment(this.groupsPlan.expirationDate).startOf("day");
      const today = this.$moment().startOf("day");
      return exp.diff(today, "days");
    },
    expiryRemainingHours() {
      if (!this.groupsPlan) return 0;
      const diff = this.groupsPlan.differenceHours;
      return typeof diff === "number" && diff > 0 ? diff : 0;
    },
    showExpiryWarning() {
      if (this.expiryWarningDismissed) return false;
      if (!this.groupsPlan || this.groupsPlan.flagPlanTest) return false;
      const d = this.expiryDaysLeft;
      return d !== null && d >= 0 && d <= this.expiryWarningDays;
    },
    expiryWarningMessage() {
      const d = this.expiryDaysLeft;
      const hrs = this.expiryRemainingHours;
      const date =
        this.groupsPlan && this.groupsPlan.expirationDate
          ? this.$moment(this.groupsPlan.expirationDate).format("DD/MM/YYYY")
          : "";
      if (this.lang === "en") {
        let m = `Your package expires on ${date} (${d} day${d === 1 ? "" : "s"} left).`;
        if (hrs > 0)
          m += ` You still have ${hrs} hour(s) to schedule — please book your remaining sessions before it expires.`;
        return m;
      }
      let m = `Tu paquete vence el ${date} (faltan ${d} día${d === 1 ? "" : "s"}).`;
      if (hrs > 0)
        m += ` Aún tienes ${hrs} hora(s) por agendar — programa tus clases restantes antes del vencimiento.`;
      return m;
    },
    getShowSelect() {
      if (this.flagPlanTest) {
        return false;
      } else {
        return this.showSelectWeek;
      }
    },
    disabledButton() {
      let p_total = this.calendarOptions.events.filter((currentValue) => {
        return currentValue.editable;
      }).length;
      if (p_total == 0) {
        return true;
      }
      let elmts = [];
      let arrayCalendar = [];
      let arrayCalendarInit = [];
      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });
      let arraySendInit = this.arrayCalendarInit.filter((currentValue) => {
        return currentValue.request;
      });

      arraySend.forEach((element) => {
        arrayCalendar.push(
          `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
        );
      });
      arraySendInit.forEach((element) => {
        arrayCalendarInit.push(
          `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
        );
      });
      if (
        this.listClassDelete.filter(
          (item) =>
            item.id > 0 && (item.isNew === undefined || item.isNew === false)
        ).length > 0
      ) {
        return false;
      } else {
        if (arrayCalendar.length > arrayCalendarInit.length) {
          elmts = arrayCalendar.filter(function (i) {
            return this.indexOf(i) < 0;
          }, arrayCalendarInit);
        } else {
          elmts = arrayCalendarInit.filter(function (i) {
            return this.indexOf(i) < 0;
          }, arrayCalendar);
        }
        if (arraySend.length == 0) {
          return true;
        } else {
          return elmts.length == 0 ? true : false;
        }
      }
    },
    isRepresentative: {
      get() {
        return this.$store.state.is_representative;
      },
    },
    dataGroup: {
      get() {
        return this.$store.state.group_id;
      },
      set(value) {
        this.$store.commit("mutateGroupId", value);
      },
    },
  },
};
</script>
<style scoped>
.red-item {
  color: red;
}
.btnEditSchedule {
  position: relative;
  bottom: 25px;
  z-index: 10;
}

.hide-background {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
}

.modal-open {
  overflow: hidden !important; 
}
.push-down {
  margin-top: 100vh; 
  transition: margin-bottom 0.3s ease-in-out;
}
</style>